// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:05:12.573Z
// Property: Shadow Hill  (ID: 6767906449167057)
// Collections: 24 amenities, 14 floorplans (live), 19 photos, 64 POIs, 2 reviews, 2 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449167057",
  "property_external_id": "5652747",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/shadow-hill-apartments-and-townhouses-sharonville-oh/w0esbyh/",
  "property_google_business_url": "https://www.google.com/maps/place/Shadow+Hill+Apartments/data=!4m2!3m1!1s0x0:0x24db4324960a7603?sa=X&ved=2ahUKEwjylrLamYCTAxXjv4kEHXhFJLwQ_BJ6BAgSEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "51219860737",
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "shadow-hill",
  "property_name": "Shadow Hill ",
  "property_website_url": "https://www.liveshadowhillapartments.com/",
  "property_domain": "https://www.liveshadowhillapartments.com/",
  "property_address": "4071 Sharon Park Ln",
  "property_full_address": "4071 Sharon Park Ln, Sharonville, OH 45241",
  "property_address_1": "4071 Sharon Park Ln",
  "property_address_2": null,
  "property_address_city": "Sharonville",
  "property_address_state": "OH",
  "property_address_zip_full": "45241-2016",
  "property_address_zip": "45241",
  "property_address_country": "US",
  "property_address_county": "Hamilton County",
  "property_neighborhood_address": "Sharonville",
  "property_address_latitude": "39.28620340000001",
  "property_address_longitude": "-84.3936186",
  "property_email": "shadowhill@aionmanagement.com",
  "property_phone": "+1 833-246-5107",
  "property_call_tracking_phone": "513-987-7685",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Shadow Hill in Sharonville, OH, where comfort meets convenience! Choose from spacious one, two, or three-bedroom apartments featuring modern amenities like swimming pools, a playground, and a clubhouse. Enjoy beautiful views, well-appointed interiors, and top-notch on-site management. Your new home awaits – schedule a tour today!",
  "property_long_description": "**Discover Your Perfect Home at Shadow Hill Apartments in Sharonville, OH!**\n\nWelcome to Shadow Hill, an inviting apartment community that meets all your lifestyle needs. Nestled in the charming city of Sharonville, our diverse floor plans offer one, two, and three-bedroom options, ensuring the perfect fit for individuals, couples, and families alike. Each thoughtfully designed apartment features an array of amenities, including air conditioning, spacious closets, and select units with cozy fireplaces, perfect for creating a warm and welcoming atmosphere.\n\nOur community boasts two rejuvenating swimming pools, a playground for the little ones, and a clubhouse ideal for gatherings with friends and neighbors. Enjoy leisurely strolls in our beautifully landscaped courtyard or challenge friends to a friendly game of sand volleyball! With on-site laundry facilities, convenient off-street parking, and manageable accessibility to nearby parks, including Sharon Woods, you'll love the balance of comfort and convenience at Shadow Hill.\n\nWe are committed to providing you with prompt and friendly maintenance services, coupled with a 24-hour emergency service, giving you peace of mind in your new home. Our apartments come equipped with efficient appliances, included window coverings, and extra storage options so you can live freely and comfortably.\n\nWith beautiful views and a welcoming atmosphere, Shadow Hill is the perfect place to start your next chapter. Don’t miss out on this wonderful opportunity—find your new home today by browsing our availability or scheduling a tour to visit our community! Your ideal living space awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd912-956f-70dc-ba6c-7e8b37974848.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
    "public_id": "019fd912-956f-70dc-ba6c-7e8b37974848",
    "storage_key": "property/6767906449167057/019fd912-956f-70dc-ba6c-7e8b37974848.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "365",
  "property_year_built": "1972",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.97260273972603",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "We’re a pet‑friendly community and we’re happy to welcome your cats and dogs. Breed restrictions apply; please contact the leasing office for details. You can have up to 2 pets per apartment, with each pet up to 100 lb. There is a one‑time, non‑refundable pet fee of $300 per pet.",
  "property_pet_policy_description": "We’re a pet-friendly community and we’re happy to welcome your cats and dogs. Breed and weight restrictions may apply; please contact the leasing office for details. You can have up to 2 pets per apartment. There is a one-time, non-refundable pet fee of $350 and monthly pet rent is $50.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://shadowhillapartments.securecafe.com/onlineleasing/shadow-hill-apartments-and-townhouses/guestlogin",
  "property_resident_portal_url": "https://shadowhill.loftliving.com/login",
  "property_apply_now_url": "https://www.liveshadowhillapartments.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019ddf82-30ec-73ea-b3ce-f48ac220ed45.webp",
  "property_primary_logo_media": {
    "alt_text": "Shadow Hill Apartments & Townhomes logo",
    "public_id": "019ddf82-30ec-73ea-b3ce-f48ac220ed45",
    "storage_key": "property/6767906449167057/019ddf82-30ec-73ea-b3ce-f48ac220ed45.webp",
    "width": 1024,
    "height": 1024
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019ddf82-31ff-7154-b298-25809510cabd.webp",
  "property_secondary_logo_media": {
    "alt_text": "Shadow Hill Apartments & Townhomes logo",
    "public_id": "019ddf82-31ff-7154-b298-25809510cabd",
    "storage_key": "property/6767906449167057/019ddf82-31ff-7154-b298-25809510cabd.webp",
    "width": 3029,
    "height": 1000
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019ddf82-31b3-777c-ab3d-098648608f88.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Shadow Hill Apartments & Townhomes logo.",
    "public_id": "019ddf82-31b3-777c-ab3d-098648608f88",
    "storage_key": "property/6767906449167057/019ddf82-31b3-777c-ab3d-098648608f88.webp",
    "width": 3029,
    "height": 1001
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019ddf82-31af-74dc-afdb-a92391929ea0.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Shadow Hill Apartments & Townhomes logo",
    "public_id": "019ddf82-31af-74dc-afdb-a92391929ea0",
    "storage_key": "property/6767906449167057/019ddf82-31af-74dc-afdb-a92391929ea0.webp",
    "width": 3029,
    "height": 1001
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 1.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1.5",
  "property_sqft_range": "650 - 1200",
  "property_sqft_min": "650",
  "property_sqft_max": "1,200",
  "property_price_range": "$1075 - $1205",
  "property_price_min": "1075",
  "property_price_max": "1205",
  "property_available_units": 17,
  "property_facebook_url": "https://www.facebook.com/Shadowhillapartments/",
  "property_instagram_url": null,
  "property_twitter_url": "https://x.com/ApartmentsHill",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJWcRfTXRRQIgRA3YKliRD2yQ",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_near=tri-county-inn-cincinnati",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Shadow Hill ",
  "property_home_romance_title": "Create Cherished Memories in Your Beautiful New Home",
  "property_home_amenities_blurb": "Welcome to Shadow Hill in Sharonville, OH, where comfort meets convenience. Choose from our spacious one, two, or three-bedroom floor plans, and revel in fantastic amenities like two shimmering swimming pools, a playful playground, and a welcoming clubhouse. Experience elevated living with beautiful views and prompt maintenance at your doorstep!",
  "property_home_floorplans_blurb": "Welcome to Shadow Hill, where comfort meets style in Sharonville, OH. Choose your ideal living space from our thoughtfully designed one, two, or three-bedroom apartment floor plans. Each home offers a perfect blend of modern amenities and warm touches. Browse our available apartments today and find the perfect fit for your lifestyle!",
  "property_home_gallery_blurb": "At Shadow Hill in Sharonville, OH, choose from spacious one, two, or three-bedroom floor plans designed for comfort. Dive into relaxation at our two swimming pools, or enjoy friendly gatherings at the clubhouse. With on-site maintenance and beautiful views, picture yourself living in this welcoming community today!",
  "property_home_neighborhood_blurb": "At Shadow Hill in Sharonville, OH, vibrant living meets serene comfort. Nestled near educational landmarks like Princeton High School and UC Blue Ash College, our spacious one-, two-, and three-bedroom apartments offer the perfect blend of convenience and community. Engage with local culture at the nearby Cincinnati Zoo and Sharon Woods park.",
  "property_home_reviews_blurb": "At Shadow Hill in Sharonville, OH, our vibrant community thrives on connection and comfort. Residents rave about our incredible staff, especially Chanel, who is \"super welcoming\" and makes apartment hunting a breeze. Experience the warmth of friendly neighbors and cozy amenities—see what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in the heart of Sharonville, Shadow Hill offers a vibrant community surrounded by engaging points of interest. Enjoy local parks like Sharon Woods and Gorman Park, or expand your mind at the Sharonville Branch Library. With top-notch schools and easy access to Cincinnati attractions, adventure awaits right at your doorstep!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Shadow Hill in Sharonville, OH, enjoy a lifestyle enriched by recreation and comfort. Choose from spacious one, two, or three-bedroom floor plans. Dive into relaxation at our two swimming pools, unwind at the clubhouse, or stay active with sand volleyball. Your oasis awaits—where convenience meets community!",
  "property_applynow_blurb": "Nestled in Sharonville, OH, Shadow Hill offers spacious one, two, and three-bedroom apartments designed for comfort and style. Enjoy resort-style amenities, including two sparkling pools and a clubhouse, all while being steps away from the scenic Sharon Woods. Secure your new home and lease online today!",
  "property_contactus_blurb": "At Shadow Hill in Sharonville, OH, your perfect home awaits among our thoughtfully designed one, two, and three-bedroom floor plans. Each space blends comfort and style, tailored to fit your lifestyle. Have questions? Our dedicated leasing team is just a message away, ready to assist you!",
  "property_faqs_blurb": "At Shadow Hill in Sharonville, OH, your ideal home awaits with thoughtfully designed one, two, and three-bedroom floor plans. Curious about amenities, pet policies, or application details? Our FAQs page is your go-to resource to unravel all the answers and help you envision life at Shadow Hill.",
  "property_floorplans_blurb": "At Shadow Hill in Sharonville, OH, the ideal apartment awaits you. With thoughtfully designed one, two, and three-bedroom floor plans, you can choose the perfect layout to suit your lifestyle. Browse our available homes and envision your future in a space made just for you.",
  "property_gallery_blurb": "At Shadow Hill in Sharonville, OH, vibrant living awaits! Choose from one, two, or three-bedroom floor plans, and indulge in resort-style amenities, including two sparkling pools and a fun playground. With beautiful views and welcoming spaces, picture yourself enjoying life here—your new adventure starts today!",
  "property_interactivemap_blurb": "Welcome to Shadow Hill in Sharonville, OH, where modern living meets a vibrant community! Choose from spacious one, two, or three-bedroom floor plans featuring beautiful views and amenities like two swimming pools, a playground, and a welcoming clubhouse. Explore our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Shadow Hill in Sharonville, OH, your furry friends are more than welcome! With space for two pets, weighing up to 100 lbs each, our community embraces tails and whiskers alike. Reach out to our leasing office today to learn about our breed-friendly policies that let your pets feel right at home.",
  "property_referafriend_blurb": "At Shadow Hill in Sharonville, OH, we believe that great friends make great neighbors. With a variety of thoughtfully designed one, two, and three-bedroom floor plans, our community has something for everyone. Refer a friend today and experience the joy of neighboring in a vibrant, welcoming environment!",
  "property_residentaccess_blurb": "Welcome to Shadow Hill in Sharonville, OH, where comfort meets convenience. Whether you need a cozy one-bedroom or a spacious three-bedroom, our versatile floor plans cater to every lifestyle. Log in to your resident portal to effortlessly handle rent payments, maintenance requests, and beyond—because your home deserves seamless living.",
  "property_reviews_blurb": "Experience the vibrant charm of Shadow Hill in Sharonville, OH, where residents rave about our incredible staff, especially Chanel: “She made the process so much easier.” With a perfect 5.0 rating, discover why our community feels like home. See what our residents have to say about living at our community!",
  "property_created_at": "1770931321616",
  "property_scheduletour_blurb": "At Shadow Hill in Sharonville, OH, our diverse floor plans cater to every lifestyle, whether you seek a cozy one-bedroom or a spacious three-bedroom retreat. Experience the vibrant community atmosphere and see what our residents love most—schedule your tour today and find your perfect home at Shadow Hill!",
  "property_thankyou_blurb": "Thank you for reaching out to Shadow Hill in Sharonville, OH! From cozy one-bedroom retreats to spacious three-bedroom havens, our diverse floor plans cater to every lifestyle. A team member will be in touch soon to help you find your perfect home. Your journey to comfort begins here!",
  "property_virtualtours_blurb": "Step into Shadow Hill in Sharonville, OH, where stylish living meets comfort. From cozy one-bedroom retreats to spacious three-bedroom homes, our diverse floor plans cater to every lifestyle. Enjoy a taste of your future home—take a virtual tour of our vibrant community and apartments for rent today!",
  "property_copyright": "2026 All Rights Reserved. Shadow Hill ",
  "property_seo_title_home": "Apartments in Sharonville, OH | Shadow Hill Apartments",
  "property_seo_description_home": "Shadow Hill Apartments offers 1, 2, and 3-bedroom apartments and townhomes in Sharonville, OH, near I‑275, Route 42, & Sharon Woods. Explore our website today!",
  "property_seo_title_floorplans": "Floor Plans | 1, 2 & 3 Bedroom Apartments in Sharonville, OH",
  "property_seo_description_floorplans": "Explore Shadow Hill’s 1, 2, and 3-bedroom apartments and townhomes in Sharonville, OH, near Kenwood and Tri‑County Malls and Sharon Woods for convenient living.",
  "property_seo_title_amenities": "Amenities | Pet-Friendly Apartments in Sharonville, OH",
  "property_seo_description_amenities": "Shadow Hill Apartments is a pet-friendly community with amenities like on-site laundry and swimming pools, all within a short distance of Sharon Woods.",
  "property_seo_title_gallery": "Gallery | Apartments for Rent in Sharonville, OH",
  "property_seo_description_gallery": "Discover apartment living at Shadow Hill Apartments in Sharonville, OH through our photo gallery showcasing 1, 2 & 3 bedroom layouts and community amenities.",
  "property_seo_title_virtualtours": "Virtual Tour | Apartments in Northside Cincinnati, Ohio",
  "property_seo_description_virtualtours": "Enjoy a virtual tour at Shadow Hill Apartments! Explore 1, 2 & 3 bedroom pet-friendly apartments and townhomes in Sharonville, OH near Cincinnati.",
  "property_seo_title_interactivemap": "Interactive Map | Apartments & Townhomes in Sharonville",
  "property_seo_description_interactivemap": "Explore Shadow Hill Apartments with our interactive leasing map to view floor plan details, availability, & find your perfect 1-3 bedroom apartment or townhome.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments Near Sharon Woods",
  "property_seo_description_neighborhood": "Shadow Hill Apartments is located in Sharonville near Cincinnati, with easy access to I‑275, I‑75, I‑71, Route 42, Sharon Woods, and Tri‑County & Kenwood Malls.",
  "property_seo_title_contact": "Contact Us | [ Townhomes for Rent in Sharonville, OH",
  "property_seo_description_contact": "Contact Shadow Hill Apartments for details on 1, 2 & 3 bedroom apartments and townhomes in Sharonville, OH, with convenient amenities and prime location.",
  "property_seo_title_faqs": "FAQs | Apartments in Sharonville, OH",
  "property_seo_description_faqs": "Uncover the answers to your burning questions at Shadow Hill in Sharonville, OH. Dive into our FAQs and find out what makes our community truly special!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Sharonville, OH",
  "property_seo_description_reviews": "Discover life at Shadow Hill in Sharonville, OH: spacious apartments, resort-style amenities, and a vibrant community. Read resident reviews!",
  "property_seo_title_applynow": "Apply Now | Apartment Living in Sharonville, OH",
  "property_seo_description_applynow": "Ready to make Shadow Hill Apartments your new home? Apply online for 1, 2 & 3 bedroom apartments or townhomes in Sharonville, OH today!",
  "property_seo_title_residentaccess": "Resident Access | Apartments for Rent Near Cincinnati",
  "property_seo_description_residentaccess": "Shadow Hill Apartments’ resident portal offers 24/7 access for maintenance requests and rent payments, making life easier for our residents in Sharonville, OH.",
  "property_seo_title_referafriend": "Refer A Friend | Shadow Hill ",
  "property_seo_description_referafriend": "Refer a friend to Shadow Hill in Sharonville, OH! Share the joy of upscale living in a vibrant community. Great friends make the best neighbors!",
  "property_seo_title_scheduletour": "Schedule a Tour | Apartments Near Cincinnati, OH",
  "property_seo_description_scheduletour": "Excited to explore Shadow Hill Apartments in person? Arrange a tour to see 1, 2 & 3 bedroom apartments and townhomes in Sharonville, OH today!",
  "property_seo_title_privacy": "Privacy Policy | Apartments for Rent in Sharonville, OH",
  "property_seo_description_privacy": "Learn how Shadow Hill Apartments protects your privacy on our website and while searching for your new 1-3 bedroom apartment or townhome in Sharonville, OH.",
  "property_seo_title_accessibility": "Accessibility | Apartments in Sharonville, OH",
  "property_seo_description_accessibility": "Explore Shadow Hill Apartments’ accessibility features and see how we make our Sharonville, OH community welcoming for all residents.",
  "property_seo_title_sitemap": "Sitemap | Sharonville, OH Apartments for Rent",
  "property_seo_description_sitemap": "Navigate our website with ease. Check out our sitemap to find all the information you need and your new apartment in Sharonville, OH.",
  "property_seo_title_thankyou": "Thank You | Sharonville Apartments For Rent",
  "property_seo_description_thankyou": "Thank you for your interest in Shadow Hill Apartments. We’ll process your request and help you find your new home in Sharonville, OH!",
  "property_seo_title_pets": "Pet Policy | Pet-Friendly Apartments in Sharonville, OH",
  "property_seo_description_pets": "Discover Shadow Hill Apartments’ pet policy designed for a comfortable and welcoming home for you and your furry companions in Sharonville, OH.",
  "property_updated_at": "1791293666028",
  "amenities": [
    {
      "id": "custom_ced29ced-f89b-4b8a-866a-68a333dd2e57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a3c822c7-21c0-4eb4-92b9-d679864bcca8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5bbda648-0a92-45a3-97cc-1f544cb1c233",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Laundry Facilities",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_56e33518-4570-476d-95b5-389297520e90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_69e32342-ebc9-4978-97cb-92e20f440d40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_39c94142-f329-41ee-abe2-db814913edfd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8fa248fc-2d8a-492f-a8d0-6448fa5a31bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c549c62e-96b7-4f9c-acfa-3d3d30c11b3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fan*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_706c179d-6145-4f8f-923d-41aafec483ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d6a27f07-e3be-4b35-9aba-0055bdac862c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_829f31ef-41b7-4d92-b71c-d30ee0bdff0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "Fireplace*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9ec4bbac-d0c6-4fba-ace8-72492f0daf9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "Garbage Disposal*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_05be6fa5-dbd4-4020-a520-fcd6de9230fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b6985cdc-922a-4c31-9321-99c912439cc5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "Patio or Balcony",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_74f0619d-24ca-4b6f-9acd-d9f8d87e68e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_950053e9-db07-4c1c-878e-0e8b4f0abc09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9f4cd844-514d-4edc-a686-6e8d66e76b5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "Walking Distance to Sharon Woods",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_36a18db6-35d9-46f9-bc14-ebf4a7f36414",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "Courtyard",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_270227d9-e8b4-462d-9bd6-4cde1d461a25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "Off Street Parking",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_edb59427-af1a-4a48-9670-2d43ad281598",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eadc5ae0-240a-4c35-ad74-77f8aa23ae5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "Sand Volleyball",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4faf9832-e87c-465e-90a9-014451e425ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "Two Swimming Pools",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_889f3b19-2658-4cd8-8f5e-9fbdf29e1dc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "Carpeting",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0d50cc74-f154-4284-a09b-9aaf0e7b51c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer Hookups*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_bff8daf1-9b04-4dec-bc1b-e971d5b9507a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92c-5dbc-73f8-918d-eef576bf3cc8.webp",
      "image_media": {
        "alt_text": "Living and dining area in an apartment with a gray sofa, coffee table, and dining set.",
        "public_id": "019fd92c-5dbc-73f8-918d-eef576bf3cc8",
        "storage_key": "property/6767906449167057/019fd92c-5dbc-73f8-918d-eef576bf3cc8.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "",
      "alt_text": "Living room with a gray sofa, coffee table, and a small dining area in an apartment at Shadow Hill, offering apartments in Sharonville, OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/fbe34a5e/dms3rep/multi/opt/a15f16e78f7d799743e98c91743c224b-b310e500-1920w.jpg"
    },
    {
      "id": "custom_af1b05a9-aa7f-4828-86dc-ce1a894447b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92c-7df7-752c-82b2-00b8c9c67705.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot in the foreground and trees in the background.",
        "public_id": "019fd92c-7df7-752c-82b2-00b8c9c67705",
        "storage_key": "property/6767906449167057/019fd92c-7df7-752c-82b2-00b8c9c67705.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Featured",
      "link": "",
      "alt_text": "Exterior view of a brick apartment building with a large parking lot and green trees at Shadow Hill, offering pet-friendly townhomes near Cincinnati,OH.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/fbe34a5e/dms3rep/multi/opt/5f64927a9c1b08298a41d6e2bd056d68-ff3c195c-1920w.jpg"
    },
    {
      "id": "custom_72575e6a-2783-42f1-9282-6462d7279eff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/01a0598b-f9d5-777b-9e96-a07ddcfd4920.webp",
      "image_media": {
        "alt_text": "Community lounge area with dining tables and seating, fireplace and TV.",
        "public_id": "01a0598b-f9d5-777b-9e96-a07ddcfd4920",
        "storage_key": "property/6767906449167057/01a0598b-f9d5-777b-9e96-a07ddcfd4920.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our spacious community lounge, perfect for resident gatherings or a quiet afternoon. Features comfortable seating, a fireplace, and a TV.",
      "link": "",
      "alt_text": "Community lounge area with dining tables and seating, fireplace and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fd54ff56-b87f-408a-9475-151fb915bb09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/01a059a4-b32d-74b9-b52c-440267183fcc.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and walkways.",
        "public_id": "01a059a4-b32d-74b9-b52c-440267183fcc",
        "storage_key": "property/6767906449167057/01a059a4-b32d-74b9-b52c-440267183fcc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover comfortable living in these charming apartment buildings, surrounded by lush green spaces and well-maintained pathways.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with manicured lawns and walkways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e8591707-6ba7-47cc-b320-3d70ae944d73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/01a0640a-1f94-7329-911f-aafb090d16c5.webp",
      "image_media": {
        "alt_text": "Playground with swings and a slide, adjacent to a swimming pool and parking lot.",
        "public_id": "01a0640a-1f94-7329-911f-aafb090d16c5",
        "storage_key": "property/6767906449167057/01a0640a-1f94-7329-911f-aafb090d16c5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring swings and a slide, conveniently located near the swimming pool and parking areas.",
      "link": "",
      "alt_text": "Playground with swings and a slide, adjacent to a swimming pool and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_85f31b1f-e2b3-4df2-8a72-20c9f3efe7a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/01a0640a-1042-745f-95c8-fdd6003404bf.webp",
      "image_media": {
        "alt_text": "Playground with swings and a slide next to a brick building.",
        "public_id": "01a0640a-1042-745f-95c8-fdd6003404bf",
        "storage_key": "property/6767906449167057/01a0640a-1042-745f-95c8-fdd6003404bf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, complete with swings and a slide.",
      "link": "",
      "alt_text": "Playground with swings and a slide next to a brick building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_16c4d3f6-0c92-475e-a923-ba4ece0cbc22",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/01a0640a-27b7-7709-9a9a-68c0b85d899d.webp",
      "image_media": {
        "alt_text": "Bathroom with a vanity, sink, toilet, and bathtub with shower.",
        "public_id": "01a0640a-27b7-7709-9a9a-68c0b85d899d",
        "storage_key": "property/6767906449167057/01a0640a-27b7-7709-9a9a-68c0b85d899d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Clean and functional bathroom featuring a vanity with sink, a toilet, and a bathtub/shower combination.",
      "link": "",
      "alt_text": "Bathroom with a vanity, sink, toilet, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dc2bff10-f588-47f8-867e-eb68f6d2f53d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/01a0640a-0ba3-7678-8216-b0a6fab04d52.webp",
      "image_media": {
        "alt_text": "Exterior of brick townhomes with red doors and green lawns.",
        "public_id": "01a0640a-0ba3-7678-8216-b0a6fab04d52",
        "storage_key": "property/6767906449167057/01a0640a-0ba3-7678-8216-b0a6fab04d52.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming brick townhomes feature red doors and are surrounded by lush green lawns and mature trees.",
      "link": "",
      "alt_text": "Exterior of brick townhomes with red doors and green lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_739c9d13-9f95-4683-9a0d-a24a7feaa09e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/01a0640a-0a70-770e-bf14-ffe4614b3de7.webp",
      "image_media": {
        "alt_text": "Clean white bathroom with a bathtub, toilet, and vanity with a large mirror.",
        "public_id": "01a0640a-0a70-770e-bf14-ffe4614b3de7",
        "storage_key": "property/6767906449167057/01a0640a-0a70-770e-bf14-ffe4614b3de7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a pristine and functional bathroom featuring a white bathtub, toilet, and vanity, perfect for your daily routine.",
      "link": "",
      "alt_text": "Clean white bathroom with a bathtub, toilet, and vanity with a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b08ec63a-db51-41b5-b24d-fac343b71fe5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/01a06409-da64-7462-afb5-b88cc2646cfd.webp",
      "image_media": {
        "alt_text": "Spacious living room with a large sectional sofa, decorative pillows, and a throw blanket.",
        "public_id": "01a06409-da64-7462-afb5-b88cc2646cfd",
        "storage_key": "property/6767906449167057/01a06409-da64-7462-afb5-b88cc2646cfd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in this spacious living area, featuring a comfortable sectional sofa perfect for lounging. Enjoy ample natural light and a serene ambiance.",
      "link": "",
      "alt_text": "Spacious living room with a large sectional sofa, decorative pillows, and a throw blanket.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c4833c1a-21b8-46ac-a02c-237deaedc1ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/01a06409-da63-7078-9d56-cfaa88793ec9.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, plush comforter, and modern wall art.",
        "public_id": "01a06409-da63-7078-9d56-cfaa88793ec9",
        "storage_key": "property/6767906449167057/01a06409-da63-7078-9d56-cfaa88793ec9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush queen-sized bed and tasteful decor for a serene atmosphere.",
      "link": "",
      "alt_text": "Bedroom with a queen-sized bed, plush comforter, and modern wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_444e2025-a34a-406a-b2e1-17cfd80e7cd6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/01a06409-b8c1-71c0-bf8c-8eff6a241978.webp",
      "image_media": {
        "alt_text": "Sand volleyball court surrounded by green grass and trees.",
        "public_id": "01a06409-b8c1-71c0-bf8c-8eff6a241978",
        "storage_key": "property/6767906449167057/01a06409-b8c1-71c0-bf8c-8eff6a241978.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a friendly game of volleyball on our sand court, perfect for recreation and fun.",
      "link": "",
      "alt_text": "Sand volleyball court surrounded by green grass and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d9e7671f-7eae-4ccc-961b-9c72c7c5bb1b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/01a06409-d80d-736e-8fff-fe85473cddcc.webp",
      "image_media": {
        "alt_text": "Clean white kitchen with granite countertops and modern appliances.",
        "public_id": "01a06409-d80d-736e-8fff-fe85473cddcc",
        "storage_key": "property/6767906449167057/01a06409-d80d-736e-8fff-fe85473cddcc.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "This kitchen features white cabinets, granite countertops, and a full suite of appliances. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Clean white kitchen with granite countertops and modern appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bca24074-7524-45a5-b03c-7648bfbc97da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/01a06409-d370-7534-bf09-f691844d9b9f.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and window view of parking lot.",
        "public_id": "01a06409-d370-7534-bf09-f691844d9b9f",
        "storage_key": "property/6767906449167057/01a06409-d370-7534-bf09-f691844d9b9f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A comfortable bedroom featuring a queen-size bed with crisp white linens and a cozy grey throw blanket, a stylish nightstand with a lamp, and a large window offering a view of the surrounding grounds.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and window view of parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4cea6b47-5353-48ac-95c9-791090a9a46c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/01a06409-d66a-7389-b1db-5f13751ca417.webp",
      "image_media": {
        "alt_text": "Spacious living and dining area with a sofa, coffee table, and dining set, overlooking a patio.",
        "public_id": "01a06409-d66a-7389-b1db-5f13751ca417",
        "storage_key": "property/6767906449167057/01a06409-d66a-7389-b1db-5f13751ca417.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and airy living and dining space featuring a comfortable sofa, modern coffee table, and a stylish dining set. Enjoy direct access to your patio.",
      "link": "",
      "alt_text": "Spacious living and dining area with a sofa, coffee table, and dining set, overlooking a patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d5524cfc-405e-41d7-9a93-6dd2cb3dca06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/01a06409-b8c2-778a-a92b-4652cee32452.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, and a dresser. A window overlooks trees and buildings.",
        "public_id": "01a06409-b8c2-778a-a92b-4652cee32452",
        "storage_key": "property/6767906449167057/01a06409-b8c2-778a-a92b-4652cee32452.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Comfortable and inviting bedroom featuring a plush queen-size bed, stylish nightstands, and a chic dresser. Large windows provide ample natural light and views of the surrounding greenery.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstands, and a dresser. A window overlooks trees and buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_23726c7f-1204-46b8-9f25-d128c46a8b00",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/01a06409-b72d-76a3-9d75-371359dfcbb3.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, light wood cabinets, and butcher block countertops.",
        "public_id": "01a06409-b72d-76a3-9d75-371359dfcbb3",
        "storage_key": "property/6767906449167057/01a06409-b72d-76a3-9d75-371359dfcbb3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring ample storage with light wood cabinetry, white appliances, and durable butcher block countertops.",
      "link": "",
      "alt_text": "Kitchen with white appliances, light wood cabinets, and butcher block countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9d80b12a-d9b3-497c-89f6-61c4d98b44cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/01a06409-b35e-7514-bbd3-2427b4af2817.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables.",
        "public_id": "01a06409-b35e-7514-bbd3-2427b4af2817",
        "storage_key": "property/6767906449167057/01a06409-b35e-7514-bbd3-2427b4af2817.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by lounge chairs and picnic tables for your relaxation and enjoyment.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_868872c0-3d1a-47d8-a71c-900da628e3ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/01a06409-b72e-769e-99b5-7e8961d31d69.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a picnic table on a sunny day.",
        "public_id": "01a06409-b72e-769e-99b5-7e8961d31d69",
        "storage_key": "property/6767906449167057/01a06409-b72e-769e-99b5-7e8961d31d69.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and picnic areas. Perfect for relaxing and unwinding.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a picnic table on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_34aba1ab-db0f-48d0-b161-28833d8f5006",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Blue Goose Sports Cafe",
      "poi_type": "Restaurants",
      "poi_address": "11060 Reading Rd, Cincinnati, OH 45241, USA",
      "poi_short_description": "Casual sports bar & restaurant offering American comfort food, beer on tap & Sunday brunch.",
      "poi_long_description": "Casual sports bar & restaurant offering American comfort food, beer on tap & Sunday brunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-5b49-703b-a930-dc934ac7f659.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-5b49-703b-a930-dc934ac7f659",
        "storage_key": "property/6767906449167057/019fd92b-5b49-703b-a930-dc934ac7f659.webp",
        "width": 1280,
        "height": 639
      },
      "poi_business_url": "http://www.bluegoosesportscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2942200487365930326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-goose-sports-cafe",
      "poi_latitude": "39.269544",
      "poi_longitude": "-84.4127743",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 513-769-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9777-7200-9253-680783122f68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9777-7200-9253-680783122f68",
        "storage_key": "property/6767906449167057/019d026f-9777-7200-9253-680783122f68.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8cP9CYpRQIgRVm1tO8HL1Cg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_27177ed6-4b2b-4354-a753-8da449cf6812",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Damn Good Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "2343 E Sharon Rd, Cincinnati, OH 45241, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-64a6-76ef-83cf-b4a46b6f988e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-64a6-76ef-83cf-b4a46b6f988e",
        "storage_key": "property/6767906449167057/019fd92b-64a6-76ef-83cf-b4a46b6f988e.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.thedamngoodbarandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12669806175158323252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "damn-good-bar--grill",
      "poi_latitude": "39.269495",
      "poi_longitude": "-84.4364863",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 513-954-0005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9753-767e-855f-794e06105152.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9753-767e-855f-794e06105152",
        "storage_key": "property/6767906449167057/019d026f-9753-767e-855f-794e06105152.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE8FBiB9TQIgRNMhcu5Yx1K8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4a4dedc6-a1a3-483f-b113-912c10efe53e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "On The Rocks Bourbon Bar & Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "11400 Chester Rd, Cincinnati, OH 45246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-68cb-739f-afdd-81b4062ab0d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-68cb-739f-afdd-81b4062ab0d8",
        "storage_key": "property/6767906449167057/019fd92b-68cb-739f-afdd-81b4062ab0d8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.marriott.com/en-us/hotels/cvgde-delta-hotels-cincinnati-sharonville/dining/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14324902183570213117&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "on-the-rocks-bourbon-bar--restaurant",
      "poi_latitude": "39.2795267",
      "poi_longitude": "-84.4421588",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 513-771-2080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9753-767e-855f-794e06105152.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9753-767e-855f-794e06105152",
        "storage_key": "property/6767906449167057/019d026f-9753-767e-855f-794e06105152.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiZAkblhPQIgR_YjrraNGzMY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6c1f8577-aa06-42cc-9bcf-5daa7d5b4e3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "New Krishna Indian Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "11974 Lebanon Rd #100, Cincinnati, OH 45241, USA",
      "poi_short_description": "Modern Indian eatery dishing up classic tandoori dishes, biryani & curry, coupled with beer & wine.",
      "poi_long_description": "Modern Indian eatery dishing up classic tandoori dishes, biryani & curry, coupled with beer & wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-6814-71ed-b4e7-de0ba8cd8b70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-6814-71ed-b4e7-de0ba8cd8b70",
        "storage_key": "property/6767906449167057/019fd92b-6814-71ed-b4e7-de0ba8cd8b70.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.newkrishnarestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10171593080112208931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-krishna-indian-cuisine",
      "poi_latitude": "39.2935086",
      "poi_longitude": "-84.3927049",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 513-769-6266",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9753-767e-855f-794e06105152.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9753-767e-855f-794e06105152",
        "storage_key": "property/6767906449167057/019d026f-9753-767e-855f-794e06105152.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8bCnkQtRQIgRI9zo0wPCKI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0f3a3383-6772-45c3-880e-b949d9d9c20b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Pho Kimmy",
      "poi_type": "Restaurants",
      "poi_address": "11974 Lebanon Rd #120, Sharonville, OH 45241, USA",
      "poi_short_description": "Functional restaurant featuring pho & Vietnamese rice & noodle dishes, plus smoothies.",
      "poi_long_description": "Functional restaurant featuring pho & Vietnamese rice & noodle dishes, plus smoothies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-75b6-711a-8b79-cf232a8753ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-75b6-711a-8b79-cf232a8753ca",
        "storage_key": "property/6767906449167057/019fd92b-75b6-711a-8b79-cf232a8753ca.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.pho-kimmy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4436806454253538778&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pho-kimmy",
      "poi_latitude": "39.2932429",
      "poi_longitude": "-84.39254629999999",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 513-769-5999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9753-767e-855f-794e06105152.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9753-767e-855f-794e06105152",
        "storage_key": "property/6767906449167057/019d026f-9753-767e-855f-794e06105152.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8bCnkQtRQIgR2k3xgvazkj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5e9d82b9-14c9-439a-9823-8a73e35dad68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Honest Indian Vegetarian Restaurant Cincinnati",
      "poi_type": "Restaurants",
      "poi_address": "12095 Lebanon Rd, Sharonville, OH 45241, USA",
      "poi_short_description": "Relaxed restaurant specializing in Indian cuisine that's made with fresh ingredients.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-7a42-7458-a0c2-8bd53cdced88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-7a42-7458-a0c2-8bd53cdced88",
        "storage_key": "property/6767906449167057/019fd92b-7a42-7458-a0c2-8bd53cdced88.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.honestcincinnati.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14002561840079861922&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "honest-indian-vegetarian-restaurant-cincinnati",
      "poi_latitude": "39.293715",
      "poi_longitude": "-84.39373859999999",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 513-554-0444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9753-767e-855f-794e06105152.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9753-767e-855f-794e06105152",
        "storage_key": "property/6767906449167057/019d026f-9753-767e-855f-794e06105152.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTQHbC1BRQIgRonhmB84XU8I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_64745268-4d98-434c-bfae-c5fb2751b181",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "2255 E Sharon Rd, Sharonville, OH 45241, USA",
      "poi_short_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_long_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-722b-76ec-9cbe-7ec92e1b6008.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-722b-76ec-9cbe-7ec92e1b6008",
        "storage_key": "property/6767906449167057/019fd92b-722b-76ec-9cbe-7ec92e1b6008.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/oh/sharonville/553/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=9595349651062488703&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "39.26852420000001",
      "poi_longitude": "-84.4387263",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 513-771-3207",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9753-767e-855f-794e06105152.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9753-767e-855f-794e06105152",
        "storage_key": "property/6767906449167057/019d026f-9753-767e-855f-794e06105152.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ34XCgf9NQIgRf34_V6uHKYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d4ef3afa-2fa2-4296-bc6c-c90e08fa10a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Benihana - Cincinnati",
      "poi_type": "Restaurants",
      "poi_address": "50 Tri County Pkwy, Cincinnati, OH 45246, USA",
      "poi_short_description": "Hibachi chain serving Japanese dishes grilled tableside by theatrical chefs.",
      "poi_long_description": "Hibachi chain serving Japanese dishes grilled tableside by theatrical chefs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-7b4b-73bd-a93b-fba402325a05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-7b4b-73bd-a93b-fba402325a05",
        "storage_key": "property/6767906449167057/019fd92b-7b4b-73bd-a93b-fba402325a05.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.benihana.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13853442437750699911&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "benihana---cincinnati",
      "poi_latitude": "39.283624",
      "poi_longitude": "-84.4703759",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 513-772-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9753-767e-855f-794e06105152.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9753-767e-855f-794e06105152",
        "storage_key": "property/6767906449167057/019d026f-9753-767e-855f-794e06105152.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGd6ZXGVOQIgRh7dzmn9QQcA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cc0c65a8-5d2d-471c-8e1b-2cdcd7cf6fb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Blue Ash Chili",
      "poi_type": "Restaurants",
      "poi_address": "11711 Princeton Pike # 231, Springdale, OH 45246, USA",
      "poi_short_description": "Diner-style fixture for double-decker sandwiches & Cincinnati-style chili in multiple combinations.",
      "poi_long_description": "Diner-style fixture for double-decker sandwiches & Cincinnati-style chili in multiple combinations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-8498-71b9-bb69-26ae5f113378.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-8498-71b9-bb69-26ae5f113378",
        "storage_key": "property/6767906449167057/019fd92b-8498-71b9-bb69-26ae5f113378.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://blueashchili.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14451572842703899924&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-ash-chili",
      "poi_latitude": "39.2888373",
      "poi_longitude": "-84.4688887",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 513-873-4663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9753-767e-855f-794e06105152.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9753-767e-855f-794e06105152",
        "storage_key": "property/6767906449167057/019d026f-9753-767e-855f-794e06105152.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq85PumhOQIgRFE0Mx-5Mjsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_68e266bf-50dd-4682-be69-28c2bedc9fd2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Perkins Restaurant & Bakery",
      "poi_type": "Restaurants",
      "poi_address": "4006 Hauck Rd, Cincinnati, OH 45241, USA",
      "poi_short_description": "Local chain serving casual American breakfast & lunch fare, from French toast to burgers.",
      "poi_long_description": "Local chain serving casual American breakfast & lunch fare, from French toast to burgers.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.perkinsrestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6680484137040691641&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "perkins-restaurant--bakery",
      "poi_latitude": "39.290931",
      "poi_longitude": "-84.39308969999999",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 513-563-1351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9753-767e-855f-794e06105152.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9753-767e-855f-794e06105152",
        "storage_key": "property/6767906449167057/019d026f-9753-767e-855f-794e06105152.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh1THGAtRQIgRuUHxi-3YtVw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2e005193-7f8e-4f0f-9188-3dd26f1b718e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "12164 Lebanon Rd, Cincinnati, OH 45241, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-7e73-7435-8f2c-3dbcf7af62bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-7e73-7435-8f2c-3dbcf7af62bf",
        "storage_key": "property/6767906449167057/019fd92b-7e73-7435-8f2c-3dbcf7af62bf.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/oh/cincinnati/sharonville-oh/014/00429?cid=loc_01400429_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5418182908243230736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "39.2965841",
      "poi_longitude": "-84.3897495",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 513-733-4910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-96f8-75ca-a484-775d1fe05348.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-96f8-75ca-a484-775d1fe05348",
        "storage_key": "property/6767906449167057/019d026f-96f8-75ca-a484-775d1fe05348.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf7nHzw5RQIgREEDu9aVAMUs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6649fb54-0f04-4405-b7a6-810222dbc698",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "11974 Lebanon Rd Ste 610, Sharonville, OH 45241, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-949f-7424-864c-ff11ca9c5184.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-949f-7424-864c-ff11ca9c5184",
        "storage_key": "property/6767906449167057/019fd92b-949f-7424-864c-ff11ca9c5184.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://locations.dollartree.com/oh/sharonville/11974-lebanon-road-ste-610?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=15906714667373111803&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "39.2930316",
      "poi_longitude": "-84.3917118",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 513-930-0569",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9b4e-76bb-a616-f743c5f2c8d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9b4e-76bb-a616-f743c5f2c8d0",
        "storage_key": "property/6767906449167057/019d026f-9b4e-76bb-a616-f743c5f2c8d0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJqwm-CihRQIgR-ylFbLYAwNw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3a5a2c0d-7835-4daf-921b-2f39199cfed9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2801 Cunningham Dr, Cincinnati, OH 45241, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-9109-75aa-a117-29d00a0f7c74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-9109-75aa-a117-29d00a0f7c74",
        "storage_key": "property/6767906449167057/019fd92b-9109-75aa-a117-29d00a0f7c74.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/3749-cincinnati-oh/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=6605112250035098515&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "39.2490692",
      "poi_longitude": "-84.4293975",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 513-769-1124",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9b4e-76bb-a616-f743c5f2c8d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9b4e-76bb-a616-f743c5f2c8d0",
        "storage_key": "property/6767906449167057/019d026f-9b4e-76bb-a616-f743c5f2c8d0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNYZ4bBJSQIgRk1PslJgSqls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e98f10fb-a90f-4702-bbae-9f10324c9c81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Gabe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "12035 Lebanon Rd, Sharonville, OH 45241, USA",
      "poi_short_description": "Discount chain stocking brand-name apparel, shoes & accessories for adults & kids, plus housewares.",
      "poi_long_description": "Discount chain stocking brand-name apparel, shoes & accessories for adults & kids, plus housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-86c2-700f-9160-299cf6f5eff8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-86c2-700f-9160-299cf6f5eff8",
        "storage_key": "property/6767906449167057/019fd92b-86c2-700f-9160-299cf6f5eff8.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://www.gabesstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4876472797969617073&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gabes",
      "poi_latitude": "39.2930412",
      "poi_longitude": "-84.3956146",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 513-563-1512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9b4e-76bb-a616-f743c5f2c8d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9b4e-76bb-a616-f743c5f2c8d0",
        "storage_key": "property/6767906449167057/019d026f-9b4e-76bb-a616-f743c5f2c8d0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ3VKXcApRQIgRsZDVTyy2rEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1fc754ee-b1c0-45c2-85fa-e8ab01287ddd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Speedway",
      "poi_type": "Shopping & Retail",
      "poi_address": "11790 Lebanon Rd, Sharonville, OH 45241, USA",
      "poi_short_description": "Gas-station & convenience-store chain with grab-&-go food, plus hot & cold beverages.",
      "poi_long_description": "Gas-station & convenience-store chain with grab-&-go food, plus hot & cold beverages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-8c73-75fc-b975-c33f14dfc7d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-8c73-75fc-b975-c33f14dfc7d1",
        "storage_key": "property/6767906449167057/019fd92b-8c73-75fc-b975-c33f14dfc7d1.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.speedway.com/locations/oh/sharonville/11790-lebanon-road-45270?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17012990296949776074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "speedway",
      "poi_latitude": "39.2868152",
      "poi_longitude": "-84.39654999999999",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 513-563-1023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9b9e-772f-b950-705b635a830f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9b9e-772f-b950-705b635a830f",
        "storage_key": "property/6767906449167057/019d026f-9b9e-772f-b950-705b635a830f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJtQoKKZ5RQIgRyt7bUIlIGuw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_39598034-eb4a-468a-a024-719bdd8d2fac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "BP",
      "poi_type": "Shopping & Retail",
      "poi_address": "4001 Hauck Rd, Sharonville, OH 45241, USA",
      "poi_short_description": "Well-stocked, clean store at a gas station featuring a beer cave and helpful staff.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-a497-731c-99a0-b916bc1ebc20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-a497-731c-99a0-b916bc1ebc20",
        "storage_key": "property/6767906449167057/019fd92b-a497-731c-99a0-b916bc1ebc20.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://map.bp.com/en-US/US/gas-station/cincinnati/bp/31197321420014524100100000000000",
      "poi_directions_map_url": "https://maps.google.com/?cid=2355290538237769606&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bp",
      "poi_latitude": "39.29079",
      "poi_longitude": "-84.39453",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 513-873-5156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9b9e-772f-b950-705b635a830f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9b9e-772f-b950-705b635a830f",
        "storage_key": "property/6767906449167057/019d026f-9b9e-772f-b950-705b635a830f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJiWNC2ApRQIgRhjeAAkSsryA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_799b79a9-fec6-4f8f-b83c-7d26d2c92514",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Sharonville Elementary",
      "poi_type": "Education",
      "poi_address": "11150 Maple St, Cincinnati, OH 45241, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.princetonschools.net/o/sharonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=10843676209345837892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sharonville-elementary",
      "poi_latitude": "39.2713594",
      "poi_longitude": "-84.4071177",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 513-864-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9bc8-728f-8b86-3e6aff4ce9d8",
        "storage_key": "property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzdbAdohRQIgRRLtpZQ96fJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8acdf2ad-fd71-43c9-b533-a960fdbea9c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Princeton Community Middle School",
      "poi_type": "Education",
      "poi_address": "200 Viking Wy, Cincinnati, OH 45246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-9ab1-700a-9a94-9e91decd31f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-9ab1-700a-9a94-9e91decd31f2",
        "storage_key": "property/6767906449167057/019fd92b-9ab1-700a-9a94-9e91decd31f2.webp",
        "width": 1280,
        "height": 532
      },
      "poi_business_url": "https://www.princetonschools.net/o/pcms",
      "poi_directions_map_url": "https://maps.google.com/?cid=8744590400994687511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "princeton-community-middle-school",
      "poi_latitude": "39.27414479999999",
      "poi_longitude": "-84.4476595",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 513-864-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9bc8-728f-8b86-3e6aff4ce9d8",
        "storage_key": "property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJC5wq_XdOQIgRFzqUjaMGW3k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_01944788-bb5a-4f82-9e79-39d0ae669c7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Princeton High School",
      "poi_type": "Education",
      "poi_address": "100 Viking Wy, Cincinnati, OH 45246, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-98ed-77da-bb93-cfc041887fa5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-98ed-77da-bb93-cfc041887fa5",
        "storage_key": "property/6767906449167057/019fd92b-98ed-77da-bb93-cfc041887fa5.webp",
        "width": 526,
        "height": 364
      },
      "poi_business_url": "https://www.princetonschools.net/o/phs",
      "poi_directions_map_url": "https://maps.google.com/?cid=6203470635480577053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "princeton-high-school",
      "poi_latitude": "39.2752973",
      "poi_longitude": "-84.4459602",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 513-864-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9bc8-728f-8b86-3e6aff4ce9d8",
        "storage_key": "property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_R160hLpcEARHfRi8qwnF1Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_aeb1ecbb-3bca-4570-9fe6-c10ad212c702",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Evendale Elementary School",
      "poi_type": "Education",
      "poi_address": "3940 Glendale Milford Rd, Cincinnati, OH 45241, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.princetonschools.net/o/evendale",
      "poi_directions_map_url": "https://maps.google.com/?cid=18073898824041001863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "evendale-elementary-school",
      "poi_latitude": "39.254641",
      "poi_longitude": "-84.4007147",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 513-864-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9bc8-728f-8b86-3e6aff4ce9d8",
        "storage_key": "property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkcnQjzNSQIgRh3NQiThj0_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1f4fe4f3-9c28-4e53-85c0-1a405739b78f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Park Montessori School",
      "poi_type": "Education",
      "poi_address": "3317 Creek Rd, Cincinnati, OH 45241, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.parkmontessori.school/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5591500295923169249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "park-montessori-school",
      "poi_latitude": "39.2702482",
      "poi_longitude": "-84.413805",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 513-563-7286",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9bc8-728f-8b86-3e6aff4ce9d8",
        "storage_key": "property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwVRtcYpRQIgR4ff94-T_mE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d0463bf7-e71e-4bc2-8020-5f26086b60ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Sharonville United Methodist Church",
      "poi_type": "Education",
      "poi_address": "3751 Creek Rd, Cincinnati, OH 45241, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-a8f9-763f-ab48-878d112c2319.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-a8f9-763f-ab48-878d112c2319",
        "storage_key": "property/6767906449167057/019fd92b-a8f9-763f-ab48-878d112c2319.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sharonvilleumc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8694739789982852114&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sharonville-united-methodist-church",
      "poi_latitude": "39.2668936",
      "poi_longitude": "-84.4015805",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 513-563-0117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9f32-778e-b17a-7e32e589bfa3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9f32-778e-b17a-7e32e589bfa3",
        "storage_key": "property/6767906449167057/019d026f-9f32-778e-b17a-7e32e589bfa3.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJRW-_hClSQIgREuRhtMXrqXg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f882c459-a490-46c0-aa7c-372f0db79ed4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Scarlet Oaks Career Campus",
      "poi_type": "Education",
      "poi_address": "300 Scarlet Oaks Dr, Cincinnati, OH 45241, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-a31f-7203-aed4-ff25164abd63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-a31f-7203-aed4-ff25164abd63",
        "storage_key": "property/6767906449167057/019fd92b-a31f-7203-aed4-ff25164abd63.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://hs.greatoaks.com/campuses/scarlet-oaks",
      "poi_directions_map_url": "https://maps.google.com/?cid=7050905710517230706&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scarlet-oaks-career-campus",
      "poi_latitude": "39.2896763",
      "poi_longitude": "-84.41433099999999",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 513-771-8810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9bc8-728f-8b86-3e6aff4ce9d8",
        "storage_key": "property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ46nY8pVRQIgRchwn7GLZ2WE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3794b5aa-f9ae-4ed6-b48c-3f55d53ec3a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Princeton City School District",
      "poi_type": "Education",
      "poi_address": "3900 Cottingham Dr, Cincinnati, OH 45241, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-ade6-7731-acea-c7ed40723183.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-ade6-7731-acea-c7ed40723183",
        "storage_key": "property/6767906449167057/019fd92b-ade6-7731-acea-c7ed40723183.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.princetonschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15262890024659942899&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "princeton-city-school-district",
      "poi_latitude": "39.2962463",
      "poi_longitude": "-84.40011559999999",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 513-864-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9bc8-728f-8b86-3e6aff4ce9d8",
        "storage_key": "property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJC5wq_XdOQIgR8321dZyt0NM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_69a0a859-ef68-457f-9a64-6d562764a81a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "UC Blue Ash College",
      "poi_type": "Education",
      "poi_address": "9555 Plainfield Rd, Blue Ash, OH 45236, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-ac67-74df-9b0e-e9d30977f83d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-ac67-74df-9b0e-e9d30977f83d",
        "storage_key": "property/6767906449167057/019fd92b-ac67-74df-9b0e-e9d30977f83d.webp",
        "width": 980,
        "height": 376
      },
      "poi_business_url": "http://www.ucblueash.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9759436764697414374&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uc-blue-ash-college",
      "poi_latitude": "39.2335121",
      "poi_longitude": "-84.399391",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 513-558-9495",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9bc8-728f-8b86-3e6aff4ce9d8",
        "storage_key": "property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu58PC1RSQIgR5kqtnwd8cIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e26a59b3-2005-4136-952b-1af1d113886b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Cincinnati State Technical and Community College",
      "poi_type": "Education",
      "poi_address": "3520 Central Pkwy, Cincinnati, OH 45223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-b0ec-70c7-9ae8-e5583b50e862.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-b0ec-70c7-9ae8-e5583b50e862",
        "storage_key": "property/6767906449167057/019fd92b-b0ec-70c7-9ae8-e5583b50e862.webp",
        "width": 1280,
        "height": 715
      },
      "poi_business_url": "https://www.cincinnatistate.edu/?utm_source=Directory+Listing&utm_medium=Link+Menu&utm_id=Directory+-+FUSIONWRX",
      "poi_directions_map_url": "https://maps.google.com/?cid=3315322650965794378&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cincinnati-state-technical-and-community-college",
      "poi_latitude": "39.150693",
      "poi_longitude": "-84.5371636",
      "poi_miles_from_property": "14.5",
      "poi_walking_minutes": "5 hours 20 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 513-569-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9bc8-728f-8b86-3e6aff4ce9d8",
        "storage_key": "property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqaD1FWK0QYgRSl6fvmJkAi4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8a1a230b-b8fd-4857-babd-6cefba02354b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Heritage Village Museum",
      "poi_type": "Entertainment",
      "poi_address": "11500 Lebanon Rd, Sharonville, OH 45241, USA",
      "poi_short_description": "Living history museum featuring live reenactments of 19th-century daily life in a recreated village.",
      "poi_long_description": "Living history museum featuring live reenactments of 19th-century daily life in a recreated village.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-b6e1-724d-8063-86b4d74292e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-b6e1-724d-8063-86b4d74292e3",
        "storage_key": "property/6767906449167057/019fd92b-b6e1-724d-8063-86b4d74292e3.webp",
        "width": 1280,
        "height": 939
      },
      "poi_business_url": "http://www.heritagevillagecincinnati.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9316981318147757401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heritage-village-museum",
      "poi_latitude": "39.2794266",
      "poi_longitude": "-84.4012942",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 513-563-9484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9f5a-70f6-9664-ce0c99dc78b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9f5a-70f6-9664-ce0c99dc78b2",
        "storage_key": "property/6767906449167057/019d026f-9f5a-70f6-9664-ce0c99dc78b2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8RR_yJpRQIgRWdUlNyWRTIE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ad27ad28-3693-4584-a839-c73fb36985e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Kings Island",
      "poi_type": "Entertainment",
      "poi_address": "Mason, OH 45040, USA",
      "poi_short_description": "Large amusement & water park with a wave pool & roller coasters, plus dining, entertainment & more.",
      "poi_long_description": "Large amusement & water park with a wave pool & roller coasters, plus dining, entertainment & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-b8c1-737a-9ecb-140858053fe6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-b8c1-737a-9ecb-140858053fe6",
        "storage_key": "property/6767906449167057/019fd92b-b8c1-737a-9ecb-140858053fe6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.visitkingsisland.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7276115120896448357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kings-island",
      "poi_latitude": "39.3429621",
      "poi_longitude": "-84.2673878",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 52 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 513-754-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9ba4-7508-b4b3-8ac942003b45",
        "storage_key": "property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA5CMtAFYQIgRZZfh5Sb0-WQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_25445dea-bdd7-414a-94ba-dead5bc6a462",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Cincinnati Zoo & Botanical Garden",
      "poi_type": "Entertainment",
      "poi_address": "3400 Vine St, Cincinnati, OH 45220, USA",
      "poi_short_description": "Animal park & conservatory with 3,000+ plant species, wildlife exhibits, rides & a 4D theater.",
      "poi_long_description": "Animal park & conservatory with 3,000+ plant species, wildlife exhibits, rides & a 4D theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-cab0-7234-ba2d-49bc90c20572.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-cab0-7234-ba2d-49bc90c20572",
        "storage_key": "property/6767906449167057/019fd92b-cab0-7234-ba2d-49bc90c20572.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cincinnatizoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10017978128428981577&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cincinnati-zoo--botanical-garden",
      "poi_latitude": "39.1441388",
      "poi_longitude": "-84.50848979999999",
      "poi_miles_from_property": "14.1",
      "poi_walking_minutes": "5 hours 12 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 513-281-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9ba4-7508-b4b3-8ac942003b45",
        "storage_key": "property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7Qfv_ZqzQYgRSV2kwAcCB4s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3cdea5c3-74dc-4cfe-a6dd-15f584dd4d68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Cincinnati Museum Center",
      "poi_type": "Entertainment",
      "poi_address": "1301 Western Ave, Cincinnati, OH 45203, USA",
      "poi_short_description": "Children explore arts, books, culture & science through interactive exhibits & educational programs.",
      "poi_long_description": "Children explore arts, books, culture & science through interactive exhibits & educational programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-b9e5-74e3-995d-6a471198b020.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-b9e5-74e3-995d-6a471198b020",
        "storage_key": "property/6767906449167057/019fd92b-b9e5-74e3-995d-6a471198b020.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "http://www.cincymuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5247810874882654937&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cincinnati-museum-center",
      "poi_latitude": "39.1099317",
      "poi_longitude": "-84.5372751",
      "poi_miles_from_property": "17.2",
      "poi_walking_minutes": "6 hours 23 mins",
      "poi_biking_minutes": "1 hour 37 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 513-287-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9f5a-70f6-9664-ce0c99dc78b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9f5a-70f6-9664-ce0c99dc78b2",
        "storage_key": "property/6767906449167057/019d026f-9f5a-70f6-9664-ce0c99dc78b2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJuZQ4_x20QYgR2QLQxS_400g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fc85a4a7-eb11-4233-88b2-44833fab3016",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "The Andrew J Brady Music Center",
      "poi_type": "Entertainment",
      "poi_address": "25 Race St, Cincinnati, OH 45202, USA",
      "poi_short_description": "Smaller live music venue featuring general admission and a balcony.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-c13e-761a-a131-811878537cee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-c13e-761a-a131-811878537cee",
        "storage_key": "property/6767906449167057/019fd92b-c13e-761a-a131-811878537cee.webp",
        "width": 1280,
        "height": 796
      },
      "poi_business_url": "http://bradymusiccenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12268571889965177956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-andrew-j-brady-music-center",
      "poi_latitude": "39.0954282",
      "poi_longitude": "-84.5136366",
      "poi_miles_from_property": "17.6",
      "poi_walking_minutes": "6 hours 31 mins",
      "poi_biking_minutes": "1 hour 45 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 513-232-5882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9ba4-7508-b4b3-8ac942003b45",
        "storage_key": "property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9ee2djWxQYgRZJy32iG5Qqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3b2e48bc-2fff-40ca-a4f2-f717e5ea0ad4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Taft Theatre",
      "poi_type": "Entertainment",
      "poi_address": "317 E 5th St, Cincinnati, OH 45202, USA",
      "poi_short_description": "A grandly refurbished 1928 performance venue, plus an intimate offshoot hosting eclectic music acts.",
      "poi_long_description": "A grandly refurbished 1928 performance venue, plus an intimate offshoot hosting eclectic music acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-cf35-756e-b48d-f0bc48500d2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-cf35-756e-b48d-f0bc48500d2e",
        "storage_key": "property/6767906449167057/019fd92b-cf35-756e-b48d-f0bc48500d2e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://tafttheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12153315474246688853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taft-theatre",
      "poi_latitude": "39.1017903",
      "poi_longitude": "-84.5077513",
      "poi_miles_from_property": "16.6",
      "poi_walking_minutes": "6 hours 8 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 513-232-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9ba4-7508-b4b3-8ac942003b45",
        "storage_key": "property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ49MhkluxQYgRVWC7ZQhAqag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_eac8dd43-2922-4820-a41a-3131ec8afb2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Bogart's",
      "poi_type": "Entertainment",
      "poi_address": "2621 Short Vine St, Cincinnati, OH 45219, USA",
      "poi_short_description": "3-story concert hall housing 6 bars & a performance space for local, national & international acts.",
      "poi_long_description": "3-story concert hall housing 6 bars & a performance space for local, national & international acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-c605-721a-8e46-51cc37a0f0fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-c605-721a-8e46-51cc37a0f0fb",
        "storage_key": "property/6767906449167057/019fd92b-c605-721a-8e46-51cc37a0f0fb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.bogarts.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=13115783879654388562&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bogarts",
      "poi_latitude": "39.12998959999999",
      "poi_longitude": "-84.50970389999999",
      "poi_miles_from_property": "14.7",
      "poi_walking_minutes": "5 hours 27 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 513-872-8801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9ba4-7508-b4b3-8ac942003b45",
        "storage_key": "property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg6GhiFuxQYgRUjOYufKfBLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_01b1f046-5d89-4d09-a07c-944d10b71b98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Cinemark Oakley Station and XD",
      "poi_type": "Entertainment",
      "poi_address": "3025 Disney St, Cincinnati, OH 45209, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-d60c-732d-91df-865cae5aa79c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-d60c-732d-91df-865cae5aa79c",
        "storage_key": "property/6767906449167057/019fd92b-d60c-732d-91df-865cae5aa79c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/oh-cincinnati/cinemark-oakley-station-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMwNjYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12036460210822654935&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-oakley-station-and-xd",
      "poi_latitude": "39.1606493",
      "poi_longitude": "-84.4303296",
      "poi_miles_from_property": "11.3",
      "poi_walking_minutes": "4 hours 12 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 513-351-2381",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9fa3-73bd-878a-bed75c467047.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9fa3-73bd-878a-bed75c467047",
        "storage_key": "property/6767906449167057/019d026f-9fa3-73bd-878a-bed75c467047.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJFyTWKGmtQYgR1ys1M8oYCqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bca4426f-5e6c-46a1-8ad4-b149092d0cde",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "TriHealth Bethesda North Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "10500 Montgomery Rd, Montgomery, OH 45242, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-cfb9-740e-97e3-b3cf507355db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-cfb9-740e-97e3-b3cf507355db",
        "storage_key": "property/6767906449167057/019fd92b-cfb9-740e-97e3-b3cf507355db.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.trihealth.com/locations/bethesda-north-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=15192249424818731889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trihealth-bethesda-north-hospital",
      "poi_latitude": "39.251667",
      "poi_longitude": "-84.3414203",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 513-865-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-a2e9-77dd-9ee9-1bc107b66037.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-a2e9-77dd-9ee9-1bc107b66037",
        "storage_key": "property/6767906449167057/019d026f-a2e9-77dd-9ee9-1bc107b66037.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJYb9AShJUQIgRcftzIVy21dI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fd5f0126-786f-445b-86e3-d5737ba4b701",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "CareFirst Urgent Care - Sharonville",
      "poi_type": "Health and Wellness",
      "poi_address": "12089 Lebanon Rd, Sharonville, OH 45241, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-e581-71da-acd4-8dabaa31eba2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-e581-71da-acd4-8dabaa31eba2",
        "storage_key": "property/6767906449167057/019fd92b-e581-71da-acd4-8dabaa31eba2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.carefirsturgentcares.com/locations/sharonville-oh/?utm_source=Google&utm_medium=Local+Listing&utm_campaign=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=11364547354427621329&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carefirst-urgent-care---sharonville",
      "poi_latitude": "39.2936033",
      "poi_longitude": "-84.3937778",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 513-914-5002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9ba4-7508-b4b3-8ac942003b45",
        "storage_key": "property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKZl_lWZRQIgR0X_DXZv7tp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e5ce5fab-c796-4453-93ed-31bb12dc8b4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Concentra Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "2884 E Kemper Rd, Cincinnati, OH 45241, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-e9c0-72db-90f3-f6243d88c2ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-e9c0-72db-90f3-f6243d88c2ac",
        "storage_key": "property/6767906449167057/019fd92b-e9c0-72db-90f3-f6243d88c2ac.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.concentra.com/?utm_source=Yext&utm_medium=Organic&utm_campaign=Homepage%20Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=7036727200181435357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concentra-urgent-care",
      "poi_latitude": "39.2842273",
      "poi_longitude": "-84.4216584",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 513-771-2233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9ba4-7508-b4b3-8ac942003b45",
        "storage_key": "property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJySCcOuxRQIgR3bskPBt6p2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a607c051-0545-4373-b7f6-d6c858ee0f67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "TriHealth Occupational Medicine - Sharonville",
      "poi_type": "Health and Wellness",
      "poi_address": "3801 Hauck Rd, Sharonville, OH 45241, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-d8d2-7561-9896-6b7a6c35fdc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-d8d2-7561-9896-6b7a6c35fdc9",
        "storage_key": "property/6767906449167057/019fd92b-d8d2-7561-9896-6b7a6c35fdc9.webp",
        "width": 1000,
        "height": 479
      },
      "poi_business_url": "https://www.trihealth.com/services/trihealth-corporate-health/occupational-medicine/trihealth-occupational-medicine/trihealth-occupational-medicine---sharonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=13413176362674638294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trihealth-occupational-medicine---sharonville",
      "poi_latitude": "39.2895088",
      "poi_longitude": "-84.39949030000001",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 513-853-1040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9ba4-7508-b4b3-8ac942003b45",
        "storage_key": "property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ823DZJ9RQIgR1k3j9tUsJbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0956eb89-e1d4-4423-a95d-24100a080411",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4000 Hauck Rd, Sharonville, OH 45241, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-dee0-7231-bc0b-cfe0a3cd2d3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-dee0-7231-bc0b-cfe0a3cd2d3a",
        "storage_key": "property/6767906449167057/019fd92b-dee0-7231-bc0b-cfe0a3cd2d3a.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/sharonville-oh-pharmacies/4000-hauck-rd-sharonville-oh-45241/storeid=6082?WT.mc_id=LS_GOOGLE_RX_6082",
      "poi_directions_map_url": "https://maps.google.com/?cid=6967300190931294170&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "39.2911296",
      "poi_longitude": "-84.39370079999999",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 513-563-0717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-96f9-748f-a3ba-d7fff372d7d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-96f9-748f-a3ba-d7fff372d7d7",
        "storage_key": "property/6767906449167057/019d026f-96f9-748f-a3ba-d7fff372d7d7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIf654QpRQIgR2pf4-5vSsGA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d1fefe4a-95e9-4baf-983f-fa3cb6793165",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "TriHealth Clinic at Walgreens-Sharonville",
      "poi_type": "Health and Wellness",
      "poi_address": "12110 Lebanon Rd, Sharonville, OH 45241, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.trihealth.com/locations/trihealth-clinic-at-walgreens",
      "poi_directions_map_url": "https://maps.google.com/?cid=11649754911242521194&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trihealth-clinic-at-walgreens-sharonville",
      "poi_latitude": "39.2949513",
      "poi_longitude": "-84.3919468",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 513-853-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9ba4-7508-b4b3-8ac942003b45",
        "storage_key": "property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpXM0XwlRQIgRagr5ZF4-rKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a6eb311f-ae0b-4292-8e49-4f30488bf484",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Kroger Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "12164 Lebanon Rd, Cincinnati, OH 45241, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-e0f5-772c-8567-257ab9445b72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-e0f5-772c-8567-257ab9445b72",
        "storage_key": "property/6767906449167057/019fd92b-e0f5-772c-8567-257ab9445b72.webp",
        "width": 796,
        "height": 503
      },
      "poi_business_url": "https://www.kroger.com/rx/pharmacy/details/014/00429?cid=loc_01400429P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=9361000467486381126&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-pharmacy",
      "poi_latitude": "39.2964758",
      "poi_longitude": "-84.3898487",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 513-733-4945",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-96f9-748f-a3ba-d7fff372d7d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-96f9-748f-a3ba-d7fff372d7d7",
        "storage_key": "property/6767906449167057/019d026f-96f9-748f-a3ba-d7fff372d7d7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf7nHzw5RQIgRRpTKFlT06IE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ccfb587d-ed7e-43a8-8f89-01ea32c60b3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Sharonville Community Center",
      "poi_type": "Health and Wellness",
      "poi_address": "10990 Thornview Dr, Cincinnati, OH 45241, USA",
      "poi_short_description": "Fitness gym, pool and exercise track, plus courts for basketball and pickleball.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-e961-775b-9684-8a5723017ada.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-e961-775b-9684-8a5723017ada",
        "storage_key": "property/6767906449167057/019fd92b-e961-775b-9684-8a5723017ada.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.sharonville.org/243/Sharonville-Community-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=6800478776415957284&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sharonville-community-center",
      "poi_latitude": "39.2690461",
      "poi_longitude": "-84.4046074",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 513-563-2895",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9ba4-7508-b4b3-8ac942003b45",
        "storage_key": "property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsdTrLShSQIgRJDHbqmonYF4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_de1cdeb6-f276-4ebd-ab25-c68cbf26aea4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Blue Ash YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "5000 YMCA Dr, Cincinnati, OH 45242, USA",
      "poi_short_description": "Sports and fitness center featuring a gym, an indoor pool and an outdoor pool, plus a sauna and a steam room.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-f939-75cf-9ff4-be8b0343b1d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-f939-75cf-9ff4-be8b0343b1d6",
        "storage_key": "property/6767906449167057/019fd92b-f939-75cf-9ff4-be8b0343b1d6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://myy.org/location/blue-ash-ymca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17831055385925529158&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-ash-ymca",
      "poi_latitude": "39.2249988",
      "poi_longitude": "-84.37538119999999",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 513-791-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9ba4-7508-b4b3-8ac942003b45",
        "storage_key": "property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJubSGKwtTQIgRRi5oiGaidPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_76ab4939-c53b-4149-936a-bebd0dedd247",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "PLAYLIST YOGA MONTGOMERY",
      "poi_type": "Health and Wellness",
      "poi_address": "9407 Montgomery Rd, Montgomery, OH 45242, USA",
      "poi_short_description": "Energizing yoga spot, offering music-driven classes led by enthusiastic instructors.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-fa12-7216-b66e-ad218f1f6fad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-fa12-7216-b66e-ad218f1f6fad",
        "storage_key": "property/6767906449167057/019fd92b-fa12-7216-b66e-ad218f1f6fad.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.playlist-yoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14718622548012702098&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "playlist-yoga-montgomery",
      "poi_latitude": "39.2269681",
      "poi_longitude": "-84.3548169",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 513-406-0156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9bc8-728f-8b86-3e6aff4ce9d8",
        "storage_key": "property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw0IEFrFTQIgRkhlajTkNQ8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_16206e45-afbb-4807-9122-84736c86cbd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Sharon Woods",
      "poi_type": "Outdoor",
      "poi_address": "11450 Lebanon Rd, Sharonville, OH 45241, USA",
      "poi_short_description": "Recreation area with paved trails, golf, boating, an indoor playground & a village museum.",
      "poi_long_description": "Recreation area with paved trails, golf, boating, an indoor playground & a village museum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-f288-7459-83c0-f7c7ad03ebad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-f288-7459-83c0-f7c7ad03ebad",
        "storage_key": "property/6767906449167057/019fd92b-f288-7459-83c0-f7c7ad03ebad.webp",
        "width": 764,
        "height": 284
      },
      "poi_business_url": "http://greatparks.org/parks/sharon-woods",
      "poi_directions_map_url": "https://maps.google.com/?cid=3394036408370234922&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sharon-woods",
      "poi_latitude": "39.2785064",
      "poi_longitude": "-84.4025248",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 513-521-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9f56-739e-a816-b662414dca37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9f56-739e-a816-b662414dca37",
        "storage_key": "property/6767906449167057/019d026f-9f56-739e-a816-b662414dca37.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJLW4w9nFRQIgRKoamiyEKGi8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_126f04d2-edf6-4240-9e14-f8f0b50f2f47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Gower Park",
      "poi_type": "Outdoor",
      "poi_address": "10997 Thornview Dr, Sharonville, OH 45241, USA",
      "poi_short_description": "Kids-focused spot featuring a playground and tennis courts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92c-0a22-748e-acf4-98f9c8dd2628.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92c-0a22-748e-acf4-98f9c8dd2628",
        "storage_key": "property/6767906449167057/019fd92c-0a22-748e-acf4-98f9c8dd2628.webp",
        "width": 958,
        "height": 1280
      },
      "poi_business_url": "http://www.ci.sharonville.oh.us/Facilities/Facility/Details/Gower-Park-3",
      "poi_directions_map_url": "https://maps.google.com/?cid=17435833058055486277&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gower-park",
      "poi_latitude": "39.2691589",
      "poi_longitude": "-84.405776",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 513-563-1144",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9f56-739e-a816-b662414dca37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9f56-739e-a816-b662414dca37",
        "storage_key": "property/6767906449167057/019d026f-9f56-739e-a816-b662414dca37.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJyXbdJihSQIgRRftojMmF-PE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8e1b4d4a-1196-4640-bc63-d98c96546d09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Gorman Park",
      "poi_type": "Outdoor",
      "poi_address": "12153 Centerdale Rd, Cincinnati, OH 45246, USA",
      "poi_short_description": "Park offering baseball/basketball fields, a playground, picnic areas, and a splash pad.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92c-0fc0-769e-8d3d-c54bf8c4da31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92c-0fc0-769e-8d3d-c54bf8c4da31",
        "storage_key": "property/6767906449167057/019fd92c-0fc0-769e-8d3d-c54bf8c4da31.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sharonville.org/Facilities/Facility/Details/Gorman-Park-4",
      "poi_directions_map_url": "https://maps.google.com/?cid=17259774433545835691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gorman-park",
      "poi_latitude": "39.2990964",
      "poi_longitude": "-84.44245149999999",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 513-563-1144",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9f56-739e-a816-b662414dca37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9f56-739e-a816-b662414dca37",
        "storage_key": "property/6767906449167057/019d026f-9f56-739e-a816-b662414dca37.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJT3xo7iZOQIgRq1TermYJh-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_739de829-9968-4ba0-8892-cad64c84e433",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Trammel Fossil Park",
      "poi_type": "Outdoor",
      "poi_address": "12000 Tramway Dr, Sharonville, OH 45241, USA",
      "poi_short_description": "Relaxed city park providing picnic tables, walking trails and hills for the exploration of fossils.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92c-15e7-7769-86c5-c4b79e38b4f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92c-15e7-7769-86c5-c4b79e38b4f1",
        "storage_key": "property/6767906449167057/019fd92c-15e7-7769-86c5-c4b79e38b4f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sharonville.org/Facilities/Facility/Details/Trammel-Fossil-Park-13",
      "poi_directions_map_url": "https://maps.google.com/?cid=814985362317155125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trammel-fossil-park",
      "poi_latitude": "39.29681679999999",
      "poi_longitude": "-84.4052713",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 513-563-2895",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9f56-739e-a816-b662414dca37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9f56-739e-a816-b662414dca37",
        "storage_key": "property/6767906449167057/019d026f-9f56-739e-a816-b662414dca37.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJpSdw6aRRQIgRNZsOet5oTws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e9a12bda-cefa-42b3-8533-b2ba108ce14f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Twin Creek Preserve",
      "poi_type": "Outdoor",
      "poi_address": "12033 Best Pl, Sharonville, OH 45241, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92c-142a-727e-a7d5-ec23891fdbdd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92c-142a-727e-a7d5-ec23891fdbdd",
        "storage_key": "property/6767906449167057/019fd92c-142a-727e-a7d5-ec23891fdbdd.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4128867764650995511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "twin-creek-preserve",
      "poi_latitude": "39.293447",
      "poi_longitude": "-84.4333271",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9f56-739e-a816-b662414dca37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9f56-739e-a816-b662414dca37",
        "storage_key": "property/6767906449167057/019d026f-9f56-739e-a816-b662414dca37.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJsain1OJRQIgRN2-VNFuvTDk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c2959b84-9043-41f5-b547-45ceefb1c3bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Sharonville Branch Library",
      "poi_type": "Entertainment",
      "poi_address": "10980 Thornview Dr, Cincinnati, OH 45241, USA",
      "poi_short_description": "Laid-back space featuring books, magazines and computers as well as films, music and telescope lending.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92c-2120-70c9-918a-165709c98a85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92c-2120-70c9-918a-165709c98a85",
        "storage_key": "property/6767906449167057/019fd92c-2120-70c9-918a-165709c98a85.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chpl.org/sharonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=8016033505689556548&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sharonville-branch-library",
      "poi_latitude": "39.2676552",
      "poi_longitude": "-84.4037697",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 513-369-6049",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9bc8-728f-8b86-3e6aff4ce9d8",
        "storage_key": "property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcZzysilSQIgRRFZBrgCsPm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8a78fe92-1170-41f0-a9ea-bff1dd973a24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Kemper Sports Park",
      "poi_type": "Outdoor",
      "poi_address": "4664 E Kemper Rd, Cincinnati, OH 45241, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92c-287c-7488-b86b-c545db8ca339.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92c-287c-7488-b86b-c545db8ca339",
        "storage_key": "property/6767906449167057/019fd92c-287c-7488-b86b-c545db8ca339.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://oh-sharonville.civicplus.com/Facilities/Facility/Details/Kemper-Sports-Park-9",
      "poi_directions_map_url": "https://maps.google.com/?cid=16848231378592453590&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kemper-sports-park",
      "poi_latitude": "39.2855991",
      "poi_longitude": "-84.3846782",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 513-563-2895",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9ba4-7508-b4b3-8ac942003b45",
        "storage_key": "property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6yENkG1RQIgR1tOXTizx0Ok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9bb72439-db01-458e-9fe5-afa7c1a8f5fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Berke Soccer Complex",
      "poi_type": "Outdoor",
      "poi_address": "Best Pl, Sharonville, OH 45241, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92c-2770-741a-b1a8-21a0c7cf00a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92c-2770-741a-b1a8-21a0c7cf00a1",
        "storage_key": "property/6767906449167057/019fd92c-2770-741a-b1a8-21a0c7cf00a1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.sharonville.org/Facilities/Facility/Details/Berke-Soccer-Complex-2",
      "poi_directions_map_url": "https://maps.google.com/?cid=4337862026364634744&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "berke-soccer-complex",
      "poi_latitude": "39.2946635",
      "poi_longitude": "-84.43191329999999",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9ba4-7508-b4b3-8ac942003b45",
        "storage_key": "property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdzV3wiBSQIgReMYerocuMzw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cda7fea8-ce78-450c-afcf-23b0fd8cd555",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Cincinnati/Northern Kentucky International Airport",
      "poi_type": "Transit",
      "poi_address": "3087 Terminal Dr, Hebron, KY 41048, USA",
      "poi_short_description": "This Midwest-area airport features a range of restaurants & shops as well as free WiFi.",
      "poi_long_description": "This Midwest-area airport features a range of restaurants & shops as well as free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92c-2110-7127-bfbc-4db5fec20354.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92c-2110-7127-bfbc-4db5fec20354",
        "storage_key": "property/6767906449167057/019fd92c-2110-7127-bfbc-4db5fec20354.webp",
        "width": 1280,
        "height": 753
      },
      "poi_business_url": "https://www.cvgairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12365270883012791774&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cincinnatinorthern-kentucky-international-airport",
      "poi_latitude": "39.051351",
      "poi_longitude": "-84.6671453",
      "poi_miles_from_property": "26.9",
      "poi_walking_minutes": "9 hours 56 mins",
      "poi_biking_minutes": "3 hours 4 mins",
      "poi_driving_minutes": "38 mins",
      "poi_business_phone": "+1 859-767-3151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-a2f4-776e-b05c-0435a554de6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-a2f4-776e-b05c-0435a554de6b",
        "storage_key": "property/6767906449167057/019d026f-a2f4-776e-b05c-0435a554de6b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJn2Ux9vLIQYgR3k11pVpEmqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_952b2d45-53ce-4b2f-b7ce-33692b29c8a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Forest Park, Park & Ride",
      "poi_type": "Transit",
      "poi_address": "1160 Kemper Meadow Dr, Cincinnati, OH 45240, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3117799908614455361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "forest-park-park--ride",
      "poi_latitude": "39.2936561",
      "poi_longitude": "-84.5221452",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 513-785-5022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-a340-772a-be99-3ecf1e2ff438.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-a340-772a-be99-3ecf1e2ff438",
        "storage_key": "property/6767906449167057/019d026f-a340-772a-be99-3ecf1e2ff438.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJjSQ9LbVOQIgRQcC1gX-mRCs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_936fd8dd-0ac8-40a3-8392-5e284d91b7de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "GE Aviation",
      "poi_type": "Employers",
      "poi_address": "1 Neumann Way, Cincinnati, OH 45215, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.geaerospace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6835781543147292045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ge-aviation",
      "poi_latitude": "39.2448741",
      "poi_longitude": "-84.4431261",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 513-243-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9ba4-7508-b4b3-8ac942003b45",
        "storage_key": "property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg2K3y41NQIgRjUV3kRiT3V4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ff1c6f11-15e1-4abb-9bba-cf2a1b5a29f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "TriHealth Bethesda North Hospital",
      "poi_type": "Employers",
      "poi_address": "10500 Montgomery Rd, Montgomery, OH 45242, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92b-cfb9-740e-97e3-b3cf507355db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92b-cfb9-740e-97e3-b3cf507355db",
        "storage_key": "property/6767906449167057/019fd92b-cfb9-740e-97e3-b3cf507355db.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.trihealth.com/locations/bethesda-north-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=15192249424818731889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trihealth-bethesda-north-hospital",
      "poi_latitude": "39.251667",
      "poi_longitude": "-84.3414203",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 513-865-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-a2e9-77dd-9ee9-1bc107b66037.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-a2e9-77dd-9ee9-1bc107b66037",
        "storage_key": "property/6767906449167057/019d026f-a2e9-77dd-9ee9-1bc107b66037.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJYb9AShJUQIgRcftzIVy21dI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e68d3012-6691-47bc-bb3d-446b5462fd1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Cincinnati Children's Hospital Medical Center",
      "poi_type": "Employers",
      "poi_address": "3333 Burnet Ave, Cincinnati, OH 45229, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92c-2c96-7018-986e-268a0f457634.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92c-2c96-7018-986e-268a0f457634",
        "storage_key": "property/6767906449167057/019fd92c-2c96-7018-986e-268a0f457634.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.cincinnatichildrens.org/?utm_source=google&utm_medium=organic&utm_campaign=profile_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17932816617407039346&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cincinnati-childrens-hospital-medical-center",
      "poi_latitude": "39.1414793",
      "poi_longitude": "-84.5008278",
      "poi_miles_from_property": "13.9",
      "poi_walking_minutes": "5 hours 9 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 513-636-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-a2e9-77dd-9ee9-1bc107b66037.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-a2e9-77dd-9ee9-1bc107b66037",
        "storage_key": "property/6767906449167057/019d026f-a2e9-77dd-9ee9-1bc107b66037.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqE5izQYgRcsfEjrMp3vg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_11f6bc74-533b-45ec-9024-c32fc9931a00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "University of Cincinnati",
      "poi_type": "Employers",
      "poi_address": "2600 Clifton Ave, Cincinnati, OH 45221, USA",
      "poi_short_description": "Longstanding research school known for its sports & healthcare programs plus modern architecture.",
      "poi_long_description": "Longstanding research school known for its sports & healthcare programs plus modern architecture.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.uc.edu/?utm_source=gmb&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=4776546961576740348&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-cincinnati",
      "poi_latitude": "39.1329219",
      "poi_longitude": "-84.51495039999999",
      "poi_miles_from_property": "14.6",
      "poi_walking_minutes": "5 hours 24 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 513-556-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9bc8-728f-8b86-3e6aff4ce9d8",
        "storage_key": "property/6767906449167057/019d026f-9bc8-728f-8b86-3e6aff4ce9d8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJexly4qzQYgR_MXAgSe0SUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dabf4f74-e838-4046-9e8b-03e6c19f76b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Procter & Gamble Company",
      "poi_type": "Employers",
      "poi_address": "1 Procter and Gamble Plz, Cincinnati, OH 45202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.pg.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16256355329530407980&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "procter--gamble-company",
      "poi_latitude": "39.103031",
      "poi_longitude": "-84.5055457",
      "poi_miles_from_property": "16.5",
      "poi_walking_minutes": "6 hours 6 mins",
      "poi_biking_minutes": "1 hour 46 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 513-983-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9ba4-7508-b4b3-8ac942003b45",
        "storage_key": "property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWRxMAFyxQYgRLCww1wotmuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_13b6308a-e623-442f-bbc0-95fd8df586b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "The Kroger Co. Corporate Headquarters",
      "poi_type": "Employers",
      "poi_address": "1014 Vine St, Cincinnati, OH 45202, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.thekrogerco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14592949496921750256&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-kroger-co-corporate-headquarters",
      "poi_latitude": "39.1068195",
      "poi_longitude": "-84.5141589",
      "poi_miles_from_property": "16.4",
      "poi_walking_minutes": "6 hours 3 mins",
      "poi_biking_minutes": "1 hour 38 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 513-762-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-96f8-75ca-a484-775d1fe05348.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-96f8-75ca-a484-775d1fe05348",
        "storage_key": "property/6767906449167057/019d026f-96f8-75ca-a484-775d1fe05348.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2UJnrFexQYgR8Ho8LUCShMo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f87405a2-6922-4c6d-b834-3a20172267d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Fifth Third Bank & ATM",
      "poi_type": "Employers",
      "poi_address": "38 Fountain Sq Plz, Cincinnati, OH 45202, USA",
      "poi_short_description": "Chain offering banking, loan, and wealth and asset management services, plus ATMs.",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://locations.53.com/oh/cincinnati/38-fountain-square-plaza.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=8244887608689240994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fifth-third-bank--atm",
      "poi_latitude": "39.1022847",
      "poi_longitude": "-84.51196619999999",
      "poi_miles_from_property": "16.7",
      "poi_walking_minutes": "6 hours 10 mins",
      "poi_biking_minutes": "1 hour 42 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 513-579-5203",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-a6d3-755f-b6cb-dd557c8adad0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-a6d3-755f-b6cb-dd557c8adad0",
        "storage_key": "property/6767906449167057/019d026f-a6d3-755f-b6cb-dd557c8adad0.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJh5DChVCxQYgRoivxyJi5a3I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_00bba1e7-5115-4123-b296-21367f4bbea7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Total Quality Logistics",
      "poi_type": "Employers",
      "poi_address": "4289 Ivy Pointe Blvd, Cincinnati, OH 45245, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.tql.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14621488233178563801&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "total-quality-logistics",
      "poi_latitude": "39.08999319999999",
      "poi_longitude": "-84.2881646",
      "poi_miles_from_property": "19.8",
      "poi_walking_minutes": "7 hours 26 mins",
      "poi_biking_minutes": "2 hours 17 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 800-580-3101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9ba4-7508-b4b3-8ac942003b45",
        "storage_key": "property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX6zsTPKpQYgR2YQpghT26co",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6028076a-ab38-4125-ba53-9a124352f3dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "The Christ Hospital",
      "poi_type": "Employers",
      "poi_address": "2139 Auburn Ave, Cincinnati, OH 45219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92c-3793-759f-93de-97665ca1d3ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92c-3793-759f-93de-97665ca1d3ed",
        "storage_key": "property/6767906449167057/019fd92c-3793-759f-93de-97665ca1d3ed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thechristhospital.com/locations/locations-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=4067038433083315335&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-christ-hospital",
      "poi_latitude": "39.1211246",
      "poi_longitude": "-84.5103073",
      "poi_miles_from_property": "15.4",
      "poi_walking_minutes": "5 hours 45 mins",
      "poi_biking_minutes": "1 hour 34 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 513-585-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-a2e9-77dd-9ee9-1bc107b66037.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-a2e9-77dd-9ee9-1bc107b66037",
        "storage_key": "property/6767906449167057/019d026f-a2e9-77dd-9ee9-1bc107b66037.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLfxroO-zQYgRh9TKI-gFcTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cf5bb658-e952-49db-a7a2-03ee7594b103",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "poi_name": "Mercy Health - Home Office",
      "poi_type": "Employers",
      "poi_address": "4600 McAuley Pl, Blue Ash, OH 45242, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019fd92c-39a3-7026-b9fb-7e04ecae31fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd92c-39a3-7026-b9fb-7e04ecae31fe",
        "storage_key": "property/6767906449167057/019fd92c-39a3-7026-b9fb-7e04ecae31fe.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://www.mercy.com/?utm_source=google&utm_medium=organic&utm_content=local_website_link",
      "poi_directions_map_url": "https://maps.google.com/?cid=2235834066670721068&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercy-health---home-office",
      "poi_latitude": "39.2450778",
      "poi_longitude": "-84.3799027",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 513-952-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-9ba4-7508-b4b3-8ac942003b45",
        "storage_key": "property/6767906449167057/019d026f-9ba4-7508-b4b3-8ac942003b45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8e1huuCzQYgRLBig2DxHBx8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_b40f34ec-0db4-469f-a0a2-47e3900e9871",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_20154544-e21c-42dd-b845-2d539778ec87",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_104c5fd5-5ead-4021-9ce7-fe1acf4ab7aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_3860926c-fcc9-4ae5-ab84-bfdbe1b87cde",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_987daac5-2abe-4d61-90a1-ebc0dd67990e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_c1ec6e08-581b-4fcd-8d6a-5a24e83b5517",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "rating": "5.0",
      "name": "Shevon Stewart",
      "text": "Very vibrant neighborhood. Neighbors are nice, heater in the unit is incredible. Not to mention the staff members chanelle to be specific is always there when we need her ♥️",
      "date": "2025-12-04",
      "title": ""
    },
    {
      "id": "custom_272db17d-afec-4d9b-a720-f65ca85ec487",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "rating": "5.0",
      "name": "Tiara W., LPN",
      "text": "Chanel was super welcoming when I\ncame today to look for an apartment. She made the process so much easier and I look forward to moving into my lovely home! Definitely need more people like her around! Thanks again!",
      "date": "2025-10-07",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_27970021-155d-43fb-907f-3ffb58ada5ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/01a0598a-2a94-775d-9ef6-82fae3a02bae.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0598a-2a94-775d-9ef6-82fae3a02bae",
        "storage_key": "property/6767906449167057/01a0598a-2a94-775d-9ef6-82fae3a02bae.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 650SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=MWuiUL72fGE"
    },
    {
      "id": "custom_8644b632-bea4-4796-bc64-f5153b2b21c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167057/01a05989-e38f-73ac-aacd-ee19cb042c9f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a05989-e38f-73ac-aacd-ee19cb042c9f",
        "storage_key": "property/6767906449167057/01a05989-e38f-73ac-aacd-ee19cb042c9f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 1BA - 850SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=RdPZ3kB5FBW"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cc45d-51eb-71de-88fb-0d6006d619d7",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-shadow-hill",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "page_item_url": "two-swimming-pools-apartments-sharonville-oh-945",
      "search_query": "apartments with two swimming pools in Sharonville OH",
      "category": "Amenity",
      "h1_title": "Apartments with Two Pools in Sharonville, OH",
      "h2_subtitle": "Discover Shadow Hill, where two swimming pools await. Located in Sharonville, OH, enjoy the perfect balance of relaxation and convenience.",
      "page_copy": "If you're searching for apartments with two swimming pools in Sharonville, OH, look no further than Shadow Hill. Nestled in a serene location, our community offers an unparalleled living experience with two pristine swimming pools that provide the perfect escape during the hot Ohio summers. Lounge by the poolside with a beautiful view or take a refreshing dip at your convenience.\n\nShadow Hill isn’t just about pools; it combines comfort with style. Residents enjoy patios or balconies, efficient appliances, and even fireplaces in select styles, making Shadow Hill an ideal place to call home. Located in the heart of Sharonville, our apartments offer both tranquility and convenience, making them perfect for anyone wanting a blend of modern amenities and peaceful living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Two Pools in Sharonville, OH",
      "seo_description": "Discover Shadow Hill in Sharonville, OH, offering beautiful apartments with two swimming pools and more. Experience premium amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-near-sharon-woods-349",
      "search_query": "pet friendly apartments near Sharon Woods",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments Near Sharon Woods",
      "h2_subtitle": "Explore Shadow Hill's pet-friendly features near Sharon Woods. Perfect for those who cherish nature and pets alike.",
      "page_copy": "For those searching for pet-friendly apartments near Sharon Woods, Shadow Hill in Sharonville, OH, offers an ideal living arrangement. These thoughtfully designed apartments cater to both you and your furry friends, with ample green spaces and easy access to Sharon Woods, where picturesque trails await.\n\nExperience a welcoming community featuring patios, balconies, and efficient appliances. Your pets will love the walks by the nearby woods, while you unwind at our two swimming pools or in one of the select apartments with a cozy fireplace. Shadow Hill combines the best of pet-friendly living with convenient amenities, making it a standout choice for anyone seeking comfort and accessibility near the natural beauty of Sharon Woods.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments Near Sharon Woods",
      "seo_description": "Find pet-friendly apartments at Shadow Hill in Sharonville, OH, close to Sharon Woods. Enjoy a blend of nature and comfort in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "page_item_url": "apartments-with-air-conditioning-hamilton-county-658",
      "search_query": "apartments with air conditioning in Hamilton County",
      "category": "Amenity",
      "h1_title": "Air-Conditioned Apartments in Hamilton County",
      "h2_subtitle": "Discover cool comfort at Shadow Hill, offering air-conditioned apartments. Ideally located in Hamilton County, it's perfect for modern living.",
      "page_copy": "Looking for apartments with air conditioning in Hamilton County? Shadow Hill in Sharonville perfectly combines comfort and modern amenities. Our air-conditioned apartments ensure a refreshing retreat from the summer heat, providing a cool and comfortable living environment year-round.\n\nBeyond air conditioning, Shadow Hill offers a wealth of features including patios, balconies, and efficient appliances. Residents can unwind by one of our two swimming pools or enjoy stunning views from select apartment styles. Located conveniently in Hamilton County, Shadow Hill provides easy access to local amenities while serving as a peaceful sanctuary from the bustle of everyday life.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apartments in Hamilton County",
      "seo_description": "Find air-conditioned apartments at Shadow Hill in Hamilton County. Enjoy comfort and convenience with modern amenities and serene surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "page_item_url": "apt-with-dishwasher-sharonville-45241-107",
      "search_query": "apt with dishwasher in Sharonville 45241",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwashers in Sharonville",
      "h2_subtitle": "Find a modern apartment with a dishwasher in Sharonville's 45241 area. Shadow Hill offers convenience and comfort for a hassle-free lifestyle.",
      "page_copy": "If you’re looking for an apt with a dishwasher in Sharonville 45241, Shadow Hill offers the convenience you need. Our thoughtfully designed apartments ensure everyday tasks, like dishwashing, are as effortless as possible, allowing you more time to enjoy life's pleasures.\n\nBeyond a dishwasher, Shadow Hill residents benefit from a wealth of amenities including efficient appliances, beautiful views, and patios or balconies. Relax by our two swimming pools or cozy up next to a fireplace in select styles, making Shadow Hill an ideal choice for those seeking a blend of convenience and comfort in the heart of Sharonville.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwashers in Sharonville",
      "seo_description": "Find your perfect apartment with a dishwasher in Sharonville, 45241 at Shadow Hill. Enjoy hassle-free living with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "page_item_url": "dedicated-parking-apartments-sharonville-332",
      "search_query": "dedicated parking apartments Sharonville",
      "category": "Amenity",
      "h1_title": "Apartments with Dedicated Parking in Sharonville",
      "h2_subtitle": "Discover the ease of dedicated parking at Shadow Hill. Perfectly located in Sharonville, we offer convenience and comfort in one place.",
      "page_copy": "For those seeking dedicated parking apartments in Sharonville, Shadow Hill offers the perfect solution. Enjoy the convenience of having a reserved parking spot, eliminating the stress of searching for parking each day.\n\nShadow Hill not only provides dedicated parking but also features amenities such as patios, beautiful views, efficient appliances, and access to two swimming pools. Some of our apartment styles even include a welcoming fireplace. Experience seamless living in a community designed for your comfort and convenience, right in the heart of Sharonville.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dedicated Parking in Sharonville",
      "seo_description": "Explore Shadow Hill's apartments with dedicated parking in Sharonville. Enjoy convenience and peace with stunning amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-sharonville-oh-457",
      "search_query": "one bedroom apartments in Sharonville OH",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Sharonville, OH",
      "h2_subtitle": "Experience the comfort of Shadow Hill's one bedroom apartments in Sharonville, OH. Modern amenities await you in our welcoming community.",
      "page_copy": "Looking for one bedroom apartments in Sharonville, OH? Shadow Hill offers well-appointed living spaces that provide both comfort and functionality. Each one-bedroom apartment is designed to cater to modern needs, with efficient appliances and stylish layouts.\n\nOutside of your apartment, indulge in community features like patios, balconies, two swimming pools, and stunning views. Select apartment styles include fireplaces for added coziness. Perfectly situated in Sharonville, Shadow Hill makes it easy to enjoy local attractions while offering a tranquil home environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Sharonville, OH",
      "seo_description": "Discover one bedroom apartments at Shadow Hill in Sharonville, OH. Enjoy modern amenities and a serene setting.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "page_item_url": "two-bedroom-floor-plans-hamilton-county-227",
      "search_query": "two bedroom floor plans Hamilton County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Floor Plans in Hamilton County",
      "h2_subtitle": "Explore the spacious two bedroom floor plans at Shadow Hill. Located in Hamilton County, we offer a blend of comfort and style.",
      "page_copy": "If you're seeking two bedroom floor plans in Hamilton County, Shadow Hill provides generous living spaces tailored to fit your lifestyle. Our two-bedroom layouts offer ample room, whether you're balancing working from home or entertaining guests.\n\nExperience the benefits of efficient appliances, beautiful views, and relaxing patios or balconies. Residents also enjoy access to two swimming pools, with select apartments featuring a cozy fireplace. Come home to Shadow Hill, where our floor plans provide the perfect blend of functionality and style in a prime Hamilton County location.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Floor Plans in Hamilton County",
      "seo_description": "Find your ideal two bedroom floor plan at Shadow Hill in Hamilton County. Enjoy spacious living with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "page_item_url": "three-bedroom-rentals-near-45241-755",
      "search_query": "three bedroom rentals near 45241",
      "category": "Floorplan",
      "h1_title": "Spacious Three Bedroom Rentals Near 45241",
      "h2_subtitle": "Discover expansive three bedroom rentals at Shadow Hill, conveniently situated near the 45241 area, offering comfort and modern amenities.",
      "page_copy": "For those in search of three bedroom rentals near 45241, Shadow Hill presents the ideal choice. Our spacious three-bedroom layouts are perfect for families or individuals needing extra space, ensuring comfort and privacy.\n\nApart from generous interiors, residents can relish in amenities such as efficient appliances, balconies with stunning views, and two inviting swimming pools. Select rentals feature a cozy fireplace, enhancing the warmth of home. Shadow Hill provides a blend of convenience and tranquility, perfectly located near 45241 for easy access to all that Sharonville has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Rentals Near 45241",
      "seo_description": "Explore Shadow Hill's spacious three bedroom rentals near 45241. Enjoy modern amenities and a prime location in Sharonville.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "page_item_url": "apartments-near-uc-blue-ash-college-sharonville-oh-289",
      "search_query": "apartments near UC Blue Ash College Sharonville OH",
      "category": "School",
      "h1_title": "Apartments Near UC Blue Ash College",
      "h2_subtitle": "Find modern apartments near UC Blue Ash College at Shadow Hill in Sharonville, OH. Enjoy convenience and comfort in student-friendly living.",
      "page_copy": "Looking for apartments near UC Blue Ash College in Sharonville, OH? Shadow Hill offers a variety of contemporary living spaces perfect for students and faculty alike. Our apartments provide a convenient location with easy access to campus while ensuring a peaceful residential experience.\n\nResidents benefit from a suite of amenities including efficient appliances, scenic balconies, and refreshing access to two swimming pools. Select units even feature a welcoming fireplace. Whether you're studying, teaching, or simply looking to enjoy near-campus living, Shadow Hill is the ideal choice for a blend of convenience and comfort near UC Blue Ash College.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near UC Blue Ash College",
      "seo_description": "Discover Shadow Hill's modern apartments near UC Blue Ash College in Sharonville, OH. Ideal student living with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "page_item_url": "apartments-near-west-chester-hospital-sharonville-369",
      "search_query": "apartments near West Chester Hospital Sharonville",
      "category": "Hospital",
      "h1_title": "Convenient Apartments Near West Chester Hospital",
      "h2_subtitle": "Find comfortable apartments near West Chester Hospital at Shadow Hill in Sharonville. Enjoy modern amenities and a prime location.",
      "page_copy": "Are you seeking comfortable apartments near West Chester Hospital in Sharonville? Shadow Hill offers an excellent living option with modern amenities and convenience. Our community is perfectly positioned to provide quick access to the hospital, ideal for healthcare professionals and visitors alike.\n\nAt Shadow Hill, residents enjoy a relaxing retreat enhanced by efficient appliances, beautiful scenic views, and inviting patios or balconies. The community features two sparkling swimming pools, and select units offer a fireplace for added charm. Experience a balanced lifestyle of work and relaxation near West Chester Hospital at Shadow Hill.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near West Chester Hospital",
      "seo_description": "Explore Shadow Hill's comfortable apartments near West Chester Hospital in Sharonville, offering modern amenities and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "page_item_url": "sharonville-apartments-near-jewish-hospital-mercy-health-788",
      "search_query": "Sharonville apartments close to The Jewish Hospital Mercy Health",
      "category": "Hospital",
      "h1_title": "Sharonville Apartments Near The Jewish Hospital",
      "h2_subtitle": "Discover comfortable Sharonville apartments close to The Jewish Hospital Mercy Health. Enjoy a blend of convenience and modern living.",
      "page_copy": "Searching for Sharonville apartments close to The Jewish Hospital Mercy Health? Shadow Hill provides the perfect residential choice with a prime location near the hospital, making it ideal for healthcare professionals and patients.\n\nOur apartments offer residents a serene living environment featuring spacious layouts, efficient appliances, and delightful amenities like balconies with beautiful views. Enjoy the relaxation of two swimming pools, and select units have a cozy fireplace for added charm. Shadow Hill combines comfort and convenience for those seeking proximity to The Jewish Hospital Mercy Health.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sharonville Apartments Near Jewish Hospital",
      "seo_description": "Find Shadow Hill's Sharonville apartments close to The Jewish Hospital Mercy Health, offering comfort and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "page_item_url": "apartments-near-summit-park-sharonville-oh-278",
      "search_query": "apartments near Summit Park Sharonville OH",
      "category": "Park",
      "h1_title": "Apartments Near Summit Park Sharonville",
      "h2_subtitle": "Enjoy vibrant living at Shadow Hill, located near Summit Park in Sharonville, OH. Experience a blend of outdoor beauty and modern convenience.",
      "page_copy": "Looking for apartments near Summit Park in Sharonville, OH? Shadow Hill places you right next to one of the community's most beloved green spaces. It's the perfect spot for nature enthusiasts and those who enjoy leisurely strolls or active outdoor recreation.\n\nThe apartments at Shadow Hill offer unmatched comfort and style with amenities such as efficient appliances, inviting balconies, and two sparkling swimming pools. Select homes also feature cozy fireplaces. Experience both the peace of nature and the convenience of urban living at the heart of Sharonville, near Summit Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Summit Park Sharonville",
      "seo_description": "Discover Shadow Hill's apartments near Summit Park in Sharonville, OH, offering outdoor access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "page_item_url": "rentals-close-to-sharon-woods-45241-958",
      "search_query": "rentals close to Sharon Woods 45241",
      "category": "Park",
      "h1_title": "Rentals Close to Sharon Woods in 45241",
      "h2_subtitle": "Explore comfortable rentals close to Sharon Woods in the 45241 area at Shadow Hill. Enjoy nature and convenience combined.",
      "page_copy": "If you're searching for rentals close to Sharon Woods in the 45241 area, Shadow Hill provides the ideal offers. Nestled near the stunning landscapes of Sharon Woods, our community ensures easy access to the tranquility of nature coupled with great amenities.\n\nAt Shadow Hill, residents enjoy modern and spacious apartments boasting efficient appliances, scenic patios or balconies, and the added luxury of two swimming pools. Select units come with a cozy fireplace to enhance comfort. Experience the ideal blend of city convenience and nature’s embrace at Shadow Hill, close to Sharon Woods.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Sharon Woods 45241",
      "seo_description": "Find Shadow Hill's rentals close to Sharon Woods in 45241. Enjoy modern living with nature nearby.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "page_item_url": "shadow-hill-near-voice-of-america-metropark-106",
      "search_query": "Shadow Hill close to Voice of America MetroPark",
      "category": "Park",
      "h1_title": "Shadow Hill Near Voice of America MetroPark",
      "h2_subtitle": "Discover Shadow Hill, close to Voice of America MetroPark. Experience vibrant living with easy access to outdoor activities.",
      "page_copy": "Shadow Hill offers a unique living experience close to Voice of America MetroPark, providing residents with easy access to expansive outdoor activities and picturesque landscapes. Ideal for those who love to explore nature while staying within reach of city amenities.\n\nOur community boasts lovely apartment features, including efficient appliances, several apartment styles with fireplaces, and expansive patios or balconies that showcase beautiful views. With two swimming pools, Shadow Hill caters to every lifestyle, ensuring a blend of comfort, convenience, and proximity to the vibrant and scenic Voice of America MetroPark.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Shadow Hill Near Voice of America Park",
      "seo_description": "Shadow Hill is located close to Voice of America MetroPark, offering convenience and access to outdoor adventures.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "page_item_url": "sharonville-rentals-near-cottell-park-307",
      "search_query": "Sharonville rentals near Cottell Park",
      "category": "Park",
      "h1_title": "Sharonville Rentals Near Cottell Park",
      "h2_subtitle": "Find ideal Sharonville rentals near Cottell Park at Shadow Hill. Enjoy modern amenities with nature at your doorstep.",
      "page_copy": "Shadow Hill presents premium Sharonville rentals conveniently located near Cottell Park, an ideal locale for individuals who love the great outdoors. Our community offers not just a place to live but a lifestyle, footsteps from beautiful trails and recreational spaces.\n\nResidents at Shadow Hill benefit from efficient appliances, spacious patios or balconies, and charming swimming pool access. Select apartment styles also feature cozy fireplaces for extra warmth. With Cottell Park nearby, you can enjoy both the excitement of city living and the peace of nature, making Shadow Hill a perfect place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sharonville Rentals Near Cottell Park",
      "seo_description": "Explore Shadow Hill rentals in Sharonville, near Cottell Park. Perfect blend of modern amenities and natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167057",
      "source": "custom",
      "page_item_url": "apartments-near-makino-park-hamilton-county-741",
      "search_query": "apartments near Makino Park Hamilton County",
      "category": "Park",
      "h1_title": "Apartments Near Makino Park in Hamilton County",
      "h2_subtitle": "Discover charming apartments near Makino Park in Hamilton County at Shadow Hill. Enjoy modern living close to nature.",
      "page_copy": "Shadow Hill offers inviting apartments near Makino Park in Hamilton County, perfect for those seeking a harmonious balance of urban convenience and natural beauty. Our community provides easy access to the scenic trails and recreational opportunities at Makino Park, ideal for anyone who loves the outdoors.\n\nResidents at Shadow Hill can enjoy spacious layouts featuring efficient appliances, private patios or balconies with beautiful views, and access to refreshing swimming pools. Select units also include a cozy fireplace for added comfort. Embrace the blend of city life and lush landscapes by choosing Shadow Hill as your home near Makino Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Makino Park, Hamilton County",
      "seo_description": "Explore modern apartments near Makino Park in Hamilton County. Shadow Hill offers a blend of comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5942"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11261867779"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5652747"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TBDPQTVD"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://liveshadowhillapartments.fatwin.com/api/websites/resources/1?x=cnRNb0F2UUVGMG1jb1B4ZU1xMld3U09jVWRzaW5ibUhidDdUdVpWRTY3N3pMZ2tSMEVEUGF3cGoyVHJ1Zmx2OVErb3ZOVDBtUS81S0kxS1R4c3FGK0E9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "51219860737"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/yzvgqzm6pln"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "efb907fc-3304-11f1-ad33-3325531dbd37"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/efb907fc-3304-11f1-ad33-3325531dbd37/tour"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/efb907fc-3304-11f1-ad33-3325531dbd37/tour"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InBLb25oSzdVMG5FUHRlRnRlWlgvL2c9PSIsInZhbHVlIjoiOEVQYUJQSkZMa2FaelZvQ2pQVFIrdz09IiwibWFjIjoiOTYyM2FkNjZmYmExOTAyMmJjYzNlMGY0NWVhOTg4MTA5MWE2NTJkZDdlNmJhN2ZkMTM4NTFhZmQ5YTVlMzcwOSJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5942",
  "custom_repli_id": "11261867779",
  "custom_realpage_id": "5652747",
  "custom_google_gtm_id": "GTM-TBDPQTVD",
  "custom_perq_script_url": "https://liveshadowhillapartments.fatwin.com/api/websites/resources/1?x=cnRNb0F2UUVGMG1jb1B4ZU1xMld3U09jVWRzaW5ibUhidDdUdVpWRTY3N3pMZ2tSMEVEUGF3cGoyVHJ1Zmx2OVErb3ZOVDBtUS81S0kxS1R4c3FGK0E9PQ2",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "51219860737",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/yzvgqzm6pln",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "efb907fc-3304-11f1-ad33-3325531dbd37",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/efb907fc-3304-11f1-ad33-3325531dbd37/tour",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/efb907fc-3304-11f1-ad33-3325531dbd37/tour",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InBLb25oSzdVMG5FUHRlRnRlWlgvL2c9PSIsInZhbHVlIjoiOEVQYUJQSkZMa2FaelZvQ2pQVFIrdz09IiwibWFjIjoiOTYyM2FkNjZmYmExOTAyMmJjYzNlMGY0NWVhOTg4MTA5MWE2NTJkZDdlNmJhN2ZkMTM4NTFhZmQ5YTVlMzcwOSJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "547ee94b-ffb2-4152-a4c3-9eaf50438f4e",
  "custom_audioeye_site_hash": "38669a4ca4a44e6f8bd4c064f3a17777"
};

export const generatedAt = '2026-10-22T20:05:12.573Z';
